<!-- src\views\teacher\CreateCourse.vue -->
<!-- Trigger deploy 1-->

<template>
	<div class="create-course-page">
		<!-- Notification - вынесен на верхний уровень для отображения поверх хедера -->
		<transition name="fade">
			<div
				v-if="notification.show"
				class="notification"
				:class="`notification--${notification.type}`"
				role="alert"
				aria-live="polite"
				:aria-label="notification.message"
			>
				{{ notification.message }}
			</div>
		</transition>

		<!-- Header -->
		<HeaderSubsection />

		<!-- Основной контент -->
		<div class="ccp-container" data-component="course-creation-page">
			<!-- Breadcrumb Navigation -->
			<nav class="breadcrumbs" aria-label="Навигация">
				<template v-if="isFromModuleView && courseId">
					<span class="breadcrumbs__link" @click="navigateToHome">
						<svg class="breadcrumbs__icon" viewBox="0 0 20 20" fill="currentColor">
							<path
								d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
							/>
						</svg>
						Главная
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__link" @click="navigateToMyCourses">
						Мои курсы
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__link" @click="navigateToCourse">
						Курс: {{ breadcrumbCourseName }}
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__link" @click="navigateToModuleView">
						{{ breadcrumbModuleTitle }}
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__current">
						Курс: {{ breadcrumbCourseName }} (редактирование)
					</span>
				</template>
				<template v-else-if="isFromTeacherCourse && courseId">
					<span class="breadcrumbs__link" @click="navigateToHome">
						<svg class="breadcrumbs__icon" viewBox="0 0 20 20" fill="currentColor">
							<path
								d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
							/>
						</svg>
						Главная
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__link" @click="navigateToMyCourses">
						Мои курсы
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__link" @click="navigateToCourse">
						Курс: {{ breadcrumbCourseName }}
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__current">
						Курс: {{ breadcrumbCourseName }} (редактирование)
					</span>
				</template>
				<template v-else>
					<span class="breadcrumbs__link" @click="navigateToHome">
						<svg class="breadcrumbs__icon" viewBox="0 0 20 20" fill="currentColor">
							<path
								d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
							/>
						</svg>
						Главная
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__link" @click="navigateToMyCourses">
						Мои курсы
					</span>
					<svg class="breadcrumbs__separator" viewBox="0 0 20 20" fill="currentColor">
						<path
							fill-rule="evenodd"
							d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
							clip-rule="evenodd"
						/>
					</svg>
					<span class="breadcrumbs__current">{{ breadcrumbTitle }}</span>
				</template>
			</nav>

			<!-- Loading Indicator -->
			<div v-if="loading" class="ccp-loading">
				<div class="ccp-loading__spinner"></div>
				<p class="ccp-loading__text">Загрузка...</p>
			</div>

			<!-- Course Cover Section -->
			<section class="ccp-cover" v-if="!loading">
				<img
					class="ccp-cover__bg"
					alt="Фон обложки курса"
						v-if="coverPreview"
						:src="coverPreview"
					/>
					<div v-else class="ccp-cover__bg ccp-cover__bg--placeholder" />

				<!-- Upload Cover Button -->
				<button
					class="ccp-cover__upload-btn"
					type="button"
					@click="handleUploadCover"
					:disabled="saving"
				>
					<div class="ccp-cover__upload-bg" />
					<span class="ccp-cover__upload-text">
						{{ coverPreview ? 'Изменить обложку' : 'Загрузить обложку' }}
					</span>
				</button>

				<!-- Title Input -->
				<div class="ccp-cover__title-group">
					<input
						v-model="courseTitle"
						class="ccp-cover__title"
						type="text"
						placeholder="Заголовок"
						@input="handleTitleChange"
					/>
				</div>

			</section>

			<!-- Tabs Navigation -->
			<nav class="ccp-tabs" role="tablist">
				<button
					v-for="tab in availableTabs"
					:key="tab.id"
					:class="[
						'ccp-tabs__item',
						{ 'ccp-tabs__item--active': activeTab === tab.id },
					]"
					:aria-selected="activeTab === tab.id"
					role="tab"
					type="button"
					:disabled="isTabDisabled(tab.id)"
					:title="
						isTabDisabled(tab.id)
							? 'Сначала создайте курс во вкладке «Описание»'
							: ''
					"
					@click="handleTabChange(tab.id)"
				>
					{{ tab.label }}
				</button>
			</nav>

			<!-- Course Description Form -->
			<div class="ccp-form" v-show="activeTab === 'description'">
				<!-- Form Header -->
				<header class="ccp-form__header">
					<h2 class="ccp-form__title">Описание курса</h2>
					<p class="ccp-form__subtitle">
						Заполните основную информацию о вашем курсе
					</p>
				</header>

				<!-- Компактная сетка полей -->
				<div class="ccp-form__grid">
					<!-- Описание (полная ширина) -->
					<div class="ccp-field ccp-field--full">
						<label class="ccp-field__label" for="course-description"
							>Описание курса</label
						>
						<textarea
							id="course-description"
							v-model="courseDescription"
							class="ccp-field__textarea ccp-field__textarea--auto"
							placeholder="Расскажите о целях курса, чему научатся студенты, какие навыки получат..."
							rows="4"
							@input="handleDescriptionChange"
						></textarea>
						<span class="ccp-field__hint">Подробное описание помогает студентам понять ценность курса</span>
					</div>

					<!-- Краткое описание (полная ширина) -->
					<div class="ccp-field ccp-field--full">
						<label class="ccp-field__label" for="short-description"
							>Краткое описание</label
						>
						<div class="ccp-field__textarea-wrapper">
							<textarea
								id="short-description"
								v-model="courseShortDescription"
								class="ccp-field__textarea"
								placeholder="Краткое описание для карточки курса (1-2 предложения)"
								rows="2"
								maxlength="500"
							></textarea>
							<span class="ccp-field__counter" :class="{ 'ccp-field__counter--warning': courseShortDescription.length > 450 }">
								{{ courseShortDescription.length }}/500
							</span>
						</div>
					</div>

					<!-- Демо видео / презентация (полная ширина) -->
					<div class="ccp-field ccp-field--full">
						<label class="ccp-field__label">Демо видео / презентация</label>
						<p class="ccp-field__description">
							Загрузите видео или презентацию PPTX, чтобы представить курс.
						</p>
						<div class="ccp-demo-upload">
							<button
								class="ccp-demo-upload__btn"
								type="button"
								@click="handleUploadDemoMedia"
								:disabled="saving"
							>
								{{
									demoMediaName
										? 'Заменить файл'
										: 'Загрузить файл'
								}}
							</button>
							<span v-if="demoMediaName" class="ccp-demo-upload__info">
								<a
									v-if="demoMediaPath"
									class="ccp-demo-upload__link"
									:href="demoMediaPath"
									target="_blank"
									rel="noopener"
								>
									{{ demoMediaName }}
								</a>
								<span v-else>{{ demoMediaName }}</span>
								<span v-if="demoMediaType" class="ccp-demo-upload__meta">
									({{ demoMediaTypeLabel }})
								</span>
							</span>
						</div>
					</div>

					<!-- Секция: Основная информация -->
					<div class="ccp-section ccp-field--full">
						<h3 class="ccp-section__title">Основная информация</h3>
					</div>

					<!-- Категория курса -->
					<div class="ccp-field">
						<label class="ccp-field__label" for="course-category"
							>Категория курса</label
						>
						<div class="ccp-field__select-wrapper">
							<select
								id="course-category"
								v-model="selectedCategory"
								class="ccp-field__select"
								@change="handleCategoryChange"
							>
								<option value="" disabled>Выберите категорию</option>
								<option
									v-for="category in categories"
									:key="category.id"
									:value="category.id"
								>
									{{ category.name }}
								</option>
							</select>
							<span class="ccp-field__select-icon" aria-hidden="true"></span>
						</div>
					</div>

					<!-- Уровень сложности -->
					<div class="ccp-field">
						<label class="ccp-field__label" for="difficulty-level"
							>Уровень сложности</label
						>
						<div class="ccp-field__select-wrapper">
							<select
								id="difficulty-level"
								v-model="difficultyLevel"
								class="ccp-field__select"
							>
								<option value="">Не указан</option>
								<option value="beginner">Начальный</option>
								<option value="intermediate">Средний</option>
								<option value="advanced">Продвинутый</option>
							</select>
							<span class="ccp-field__select-icon" aria-hidden="true"></span>
						</div>
					</div>

					<!-- Секция: Параметры курса -->
					<div class="ccp-section ccp-field--full">
						<h3 class="ccp-section__title">Параметры курса</h3>
					</div>

					<!-- Продолжительность (часы) -->
					<div class="ccp-field">
						<label class="ccp-field__label" for="duration-hours"
							>Продолжительность (часы)</label
						>
						<input
							id="duration-hours"
							v-model.number="durationHours"
							class="ccp-field__input"
							type="number"
							min="0"
							placeholder="40"
						/>
					</div>

					<!-- Цена -->
					<div class="ccp-field">
						<label class="ccp-field__label" for="price">Цена (₽)</label>
						<input
							id="price"
							v-model.number="price"
							class="ccp-field__input"
							type="number"
							min="0"
							step="0.01"
							placeholder="0.00"
							:disabled="isFree"
						/>
					</div>

					<!-- Максимум студентов -->
					<div class="ccp-field ccp-field--full">
						<label class="ccp-field__label">Максимум студентов</label>
						<div class="ccp-field__toggle-group">
							<label class="ccp-field__checkbox-label">
								<input
									v-model="unlimitedStudents"
									type="checkbox"
									class="ccp-field__checkbox"
									@change="handleUnlimitedToggle"
								/>
								<span>Без ограничений</span>
							</label>
							<input
								v-if="!unlimitedStudents"
								v-model.number="maxStudents"
								class="ccp-field__input ccp-field__input--inline"
								type="number"
								min="1"
								placeholder="Введите количество"
							/>
						</div>
					</div>

					<!-- Секция: Публикация -->
					<div class="ccp-section ccp-field--full">
						<h3 class="ccp-section__title">Настройки публикации</h3>
					</div>

					<!-- Группа чекбоксов публикации -->
					<div class="ccp-field ccp-field--full">
						<div class="ccp-publish-settings">
							<label class="ccp-publish-option">
								<input
									v-model="isFree"
									type="checkbox"
									class="ccp-field__checkbox"
								/>
								<div class="ccp-publish-option__content">
									<span class="ccp-publish-option__title">Бесплатный курс</span>
									<span class="ccp-publish-option__hint">Курс будет доступен всем без оплаты</span>
								</div>
							</label>
							
							<label class="ccp-publish-option">
								<input
									v-model="isPublished"
									type="checkbox"
									class="ccp-field__checkbox"
								/>
								<div class="ccp-publish-option__content">
									<span class="ccp-publish-option__title">Опубликован</span>
									<span class="ccp-publish-option__hint">Курс виден студентам в каталоге</span>
								</div>
							</label>
							
							<label class="ccp-publish-option">
								<input
									v-model="isHidden"
									type="checkbox"
									class="ccp-field__checkbox"
								/>
								<div class="ccp-publish-option__content">
									<span class="ccp-publish-option__title">Скрыт от общего списка</span>
									<span class="ccp-publish-option__hint">Доступен только по прямой ссылке</span>
								</div>
							</label>
						</div>
					</div>

					<!-- Секция: Теги и категории -->
					<div class="ccp-section ccp-field--full">
						<h3 class="ccp-section__title">Теги и категории</h3>
					</div>

					<!-- Метки курса (полная ширина) -->
					<div class="ccp-field ccp-field--full">
						<label class="ccp-field__label">Метки курса</label>
						<p class="ccp-field__description">Добавьте ключевые слова для поиска (например: сталь, производство, безопасность)</p>
						<div class="ccp-tags">
							<input
								v-model="newTag"
								class="ccp-tags__input"
								type="text"
								placeholder="Введите метку..."
								@keypress.enter="handleAddTag"
							/>
							<button
								class="ccp-tags__add-btn ccp-tags__add-btn--secondary"
								type="button"
								@click="handleAddTag"
							>
								+ Добавить
							</button>
						</div>

						<!-- Tags List -->
						<div v-if="courseTags.length > 0" class="ccp-tags__list">
							<span
								v-for="(tag, index) in courseTags"
								:key="index"
								class="ccp-tags__item ccp-tags__item--tag"
							>
								{{ tag }}
								<button
									class="ccp-tags__remove"
									type="button"
									@click="handleRemoveTag(index)"
									aria-label="Удалить метку"
								>
									×
								</button>
							</span>
						</div>
					</div>

					<!-- Добавить категорию (полная ширина) -->
					<div class="ccp-field ccp-field--full ccp-field--custom-category">
						<label class="ccp-field__label" for="custom-category"
							>Создать новую категорию</label
						>
						<p class="ccp-field__description">Если нужной категории нет в списке, создайте свою</p>
						<div class="ccp-tags">
							<input
								id="custom-category"
								v-model="newCategoryName"
								class="ccp-tags__input"
								type="text"
								placeholder="Например: Обучение персонала"
								spellcheck="true"
								lang="ru"
								@input="handleCustomCategoryInput"
							/>
							<button
								class="ccp-tags__add-btn ccp-tags__add-btn--secondary"
								type="button"
								@click="handleAddCustomCategory"
							>
								+ Создать
							</button>
						</div>
						<p
							v-if="categoryValidationError"
							class="ccp-field__message ccp-field__message--error"
						>
							{{ categoryValidationError }}
						</p>

						<div
							v-if="customCategories.length > 0"
							class="ccp-tags__list ccp-tags__list--categories"
						>
							<span
								v-for="category in customCategories"
								:key="category.id"
								class="ccp-tags__item ccp-tags__item--category"
							>
								{{ category.name }}
								<button
									class="ccp-tags__remove"
									type="button"
									@click="handleRemoveCustomCategory(category.id)"
									aria-label="Удалить категорию"
								>
									×
								</button>
							</span>
						</div>
					</div>

					<!-- Секция: Представление курса -->
					<div class="ccp-section ccp-field--full">
						<h3 class="ccp-section__title">Представление курса</h3>
					</div>

					<!-- Для кого этот курс -->
					<div class="ccp-field">
						<label class="ccp-field__label" for="presentation-audience"
							>Для кого этот курс</label
						>
						<textarea
							id="presentation-audience"
							v-model="presentationAudience"
							class="ccp-field__textarea"
							placeholder="Опишите целевую аудиторию: должности, уровень подготовки, интересы..."
							rows="2"
							maxlength="100"
						></textarea>
						<span class="ccp-field__counter">
							{{ presentationAudience.length }}/100
						</span>
					</div>

					<!-- Как будет представлен курс -->
					<div class="ccp-field">
						<label class="ccp-field__label" for="presentation-format"
							>Как будет представлен курс</label
						>
						<textarea
							id="presentation-format"
							v-model="presentationFormat"
							class="ccp-field__textarea"
							placeholder="Формат, материалы, практики, встречи, длительность модулей..."
							rows="2"
							maxlength="100"
						></textarea>
						<span class="ccp-field__counter">
							{{ presentationFormat.length }}/100
						</span>
					</div>

					<!-- Что получит студент -->
					<div class="ccp-field">
						<label class="ccp-field__label" for="presentation-benefits"
							>Что получит студент</label
						>
						<textarea
							id="presentation-benefits"
							v-model="presentationBenefits"
							class="ccp-field__textarea"
							placeholder="Навыки, знания, сертификаты, проекты..."
							rows="2"
							maxlength="100"
						></textarea>
						<span class="ccp-field__counter">
							{{ presentationBenefits.length }}/100
						</span>
					</div>

					<!-- Результат курса -->
					<div class="ccp-field">
						<label class="ccp-field__label" for="presentation-outcome"
							>Результат курса</label
						>
						<textarea
							id="presentation-outcome"
							v-model="presentationOutcome"
							class="ccp-field__textarea"
							placeholder="Итог, который получит студент после завершения курса..."
							rows="2"
							maxlength="100"
						></textarea>
						<span class="ccp-field__counter">
							{{ presentationOutcome.length }}/100
						</span>
					</div>
				</div>

				<!-- Action Buttons - теперь фиксированные внизу -->
				<div class="ccp-actions ccp-actions--sticky">
					<button
						class="ccp-actions__btn ccp-actions__btn--cancel"
						type="button"
						@click="handleCancel"
						:disabled="saving"
					>
						Отменить
					</button>
					<button
						class="ccp-actions__btn ccp-actions__btn--save"
						type="button"
						@click="handleSave"
						:disabled="saving"
					>
						{{ saving ? 'Сохранение...' : 'Сохранить' }}
					</button>
				</div>
			</div>

			<!-- Module Creation Section -->
			<div class="ccp-module-creation" v-show="activeTab === 'modules'">
				<CourseCreationPage
					ref="courseCreationPage"
					:auto-open-form="autoOpenModuleForm"
					:course-id="courseId"
					:editing-module-id="editingModuleId"
					:modules="modules"
					:saving="saving"
					@save-module="handleSaveModule"
					@save-draft="handleSaveDraft"
					@draft-updated="handleSaveDraft"
					@cancel="handleCancelModuleCreation"
					@form-opened="handleModuleFormOpened"
					@edit-module="handleEditModule"
					@toggle-visibility="handleToggleModuleVisibility"
					@delete-module="handleDeleteModule"
				@close-editing-form="handleCloseEditingForm"
				/>
			</div>

			<!-- Conferences Section -->
			<div class="ccp-conferences" v-show="activeTab === 'conferences'">
				<ConferencesList
					:conferences="conferences"
					:loading="conferencesLoading"
					@create-conference="openConferenceForm()"
					@edit-conference="handleEditConference"
					@delete-conference="handleDeleteConference"
				/>
				<div
					v-if="showConferenceForm"
					class="ccp-modal-overlay"
					@click.self="closeConferenceForm"
				>
					<ConferenceForm
						ref="conferenceForm"
						:conference="selectedConference"
						:saving="savingConference"
						@conference-submit="handleConferenceSubmit"
						@cancel="closeConferenceForm"
					/>
				</div>
			</div>

			<!-- Certificates Section -->
			<div class="ccp-certificates" v-show="activeTab === 'certificates'">
				<CertificatesManager
					v-if="courseId"
					:courseId="courseId"
					:courseName="courseTitle"
					:certificates="certificates"
					:loading="certificatesLoading"
					@create-certificate="handleCreateCertificate"
					@update-certificate="handleUpdateCertificate"
					@delete-certificate="handleDeleteCertificate"
					@error="handleCertificateError"
				/>
			</div>

			<!-- FAQ Section -->
			<div class="ccp-faq" v-show="activeTab === 'faq'">
				<FAQList
					:faqs="faqs"
					:loading="faqsLoading"
					@create-faq="openFaqForm()"
					@edit-faq="handleEditFaq"
					@delete-faq="handleDeleteFaq"
					@toggle-publish="handleToggleFaqPublish"
					@reorder-faqs="handleReorderFaqs"
				/>
				<div
					v-if="showFaqForm"
					class="ccp-modal-overlay"
				>
					<FAQForm
						ref="faqForm"
						:faq="selectedFaq"
						:saving="savingFaq"
						@submit="handleFaqSubmit"
						@cancel="closeFaqForm"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HeaderSubsection from './TeacherDashboard/DivWrapperScreen/sections/HeaderSubsection.vue'
import ViewSubsection from './TeacherDashboard/DivWrapperScreen/sections/ViewSubsection.vue'
import CourseCreationPage from './TeacherDashboard/DivWrapperScreen/sections/CourseCreationPage.vue'
import ModuleTestsSection from './TeacherDashboard/DivWrapperScreen/sections/ModuleTestsSection.vue'
import ModuleCard from '@/components/ModuleCard.vue'
import MaterialsSlider from '@/components/MaterialsSlider.vue'
import ConferencesList from '@/components/course/ConferencesList.vue'
import ConferenceForm from '@/components/course/ConferenceForm.vue'
import CertificatesManager from '@/components/course/CertificatesManager.vue'
import FAQList from '@/components/course/FAQList.vue'
import FAQForm from '@/components/course/FAQForm.vue'

import {
	coursesService,
	modulesService,
	conferencesService,
	certificatesService,
	faqService,
} from '@/services'
import eventBus from '@/utils/eventBus'
import authState from '@/utils/authState'

const debounce = (fn, wait = 0) => {
	let timeout
	const debounced = function (...args) {
		const later = () => {
			timeout = null
			fn.apply(this, args)
		}
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
	}
	debounced.cancel = () => {
		clearTimeout(timeout)
		timeout = null
	}
	return debounced
}

export default {
	name: 'CreateCourse',
	components: {
		HeaderSubsection,
		ViewSubsection,
		CourseCreationPage,
		ModuleTestsSection,
		ModuleCard,
		MaterialsSlider,
		ConferencesList,
		ConferenceForm,
		CertificatesManager,
		FAQList,
		FAQForm,
	},
	props: {
		routeMode: {
			type: String,
			default: 'create',
		},
		routeCourseId: {
			type: [String, Number],
			default: null,
		},
	},
	data() {
		return {
			// Course data
			courseId: null,
			courseTitle: '',
			courseSubtitle: '',
			courseDescription: '',
			courseShortDescription: '',
			selectedCategory: '',
			courseTags: [],
			newTag: '',
			coverFile: null,
			coverPreview: null,
			demoMediaFile: null,
			demoMediaPath: null,
			demoMediaName: '',
			demoMediaType: '',
			presentationAudience: '',
			presentationFormat: '',
			presentationBenefits: '',
			presentationOutcome: '',
			
			// Новые поля из БД
			difficultyLevel: '',
			durationHours: null,
			price: 0,
			maxStudents: null,
			unlimitedStudents: true,
			isFree: false,
			isPublished: true,
			isHidden: false,

			// UI state
			activeTab: 'description',
			showModuleCreation: false,
			autoOpenModuleForm: false,
			editingModuleId: null,
			loading: false,
			saving: false,
			error: null,
			isEditMode: false,

			// Course content
			modules: [],

			// Conferences
			conferences: [],
			conferencesLoading: false,
			showConferenceForm: false,
			selectedConference: null,
			savingConference: false,

			// Certificates
			certificates: [],
			certificatesLoading: false,

			// FAQ
			faqs: [],
			faqsLoading: false,
			showFaqForm: false,
			selectedFaq: null,
			savingFaq: false,

			// Tabs
			tabs: [
				{ id: 'description', label: 'Описание' },
				{ id: 'modules', label: 'Модули' },
				{ id: 'conferences', label: 'Конференции' },
				{ id: 'certificates', label: 'Сертификаты' },
				{ id: 'faq', label: 'FAQ' },
			],

			// Categories list
			categories: [
				{ id: 'tech', name: 'Техническая подготовка' },
				{ id: 'sales', name: 'Продажи' },
				{ id: 'management', name: 'Управление и менеджмент' },
				{ id: 'business', name: 'Бизнес' },
			],

			// Custom category input
			newCategoryName: '',
			categoryValidationError: '',

			// Notifications
			notification: {
				show: false,
				message: '',
				type: 'success',
			},
			_notificationTimeoutId: null,
			_isBodyScrollLocked: false,
			_prevBodyOverflow: '',
			_prevBodyPaddingRight: '',
		}
	},
	async mounted() {
		window.scrollTo(0, 0)

		// Слушатель события logout
		window.addEventListener('auth:logout', this.handleAuthLogout)

		// Проверка возврата из preview в Bitrix
		const isBitrix = localStorage.getItem('bitrix24_mode') === 'true'
		if (isBitrix) {
			const wasInPreview = sessionStorage.getItem('bitrix_preview_opened') === 'true'
			console.log('[Bitrix] mounted, checking preview flag:', wasInPreview)
			
			if (wasInPreview) {
				console.log('[Bitrix] Возврат из preview обнаружен в mounted')
				sessionStorage.removeItem('bitrix_preview_opened')
				// Закрываем форму редактирования и переключаем на модули
				this.$nextTick(() => {
					this.handleCloseEditingForm()
				})
			}
		}

		const courseId = this.resolvedRouteCourseId
		this.isEditMode = this.routeIntentMode !== 'create'

		if (courseId) {
			const isPageRefresh =
				sessionStorage.getItem('createCourse_isOnPage') === 'true'
			const savedCourseId = localStorage.getItem('createCourse_courseId')

			if (isPageRefresh && savedCourseId === courseId) {
				this.restoreState()
			} else {
				this.activeTab = 'description'
			}

			localStorage.setItem('createCourse_courseId', courseId)
			sessionStorage.setItem('createCourse_isOnPage', 'true')

			await this.loadCourse(courseId)
		} else {
			this.activeTab = 'description'
			localStorage.removeItem('createCourse_state')
			localStorage.removeItem('createCourse_courseId')
			sessionStorage.removeItem('createCourse_isOnPage')
		}
		const tab = this.$route.query.tab
		if (this.availableTabs.some(t => t.id === tab)) {
			this.activeTab = tab
		}
		this.ensureAllowedActiveTab()
	},

	beforeUnmount() {
		sessionStorage.removeItem('createCourse_isOnPage')
		// Удаляем слушатель события logout
		window.removeEventListener('auth:logout', this.handleAuthLogout)
		if (this._notificationTimeoutId) {
			clearTimeout(this._notificationTimeoutId)
			this._notificationTimeoutId = null
		}
		if (this.handleDescriptionChange?.cancel) {
			this.handleDescriptionChange.cancel()
		}
		this.unlockBodyScroll()
	},

	beforeRouteLeave(to, from, next) {
		// ✅ ПРИОРИТЕТ 1: Проверяем глобальный флаг logout
		if (authState.isLoggingOut) {
			console.log('🔓 [CreateCourse] Logout in progress, allowing navigation')
			this.forceCloseModuleEditor()
			next()
			return
		}

		// ✅ ПРИОРИТЕТ 2: Проверяем маршрут на logout-related
		if (this.isLogoutRoute(to)) {
			console.log('🔓 [CreateCourse] Logout route detected, allowing navigation')
			this.forceCloseModuleEditor()
			next()
			return
		}

		// Стандартная проверка блокировки
		if (this.isModuleEditingLocked(true)) {
			next(false)
			return
		}
		next()
	},

	watch: {
		routeCourseId(newId) {
			if (newId) {
				this.loadConferences()
				this.loadCertificates()
				this.loadFaqs()
				this.isEditMode = this.routeIntentMode !== 'create'
			}
		},
		activeTab() {
			this.saveState()
		},
		showModuleCreation() {
			this.saveState()
		},
		showFaqForm() {
			this.syncModalScrollLock()
		},
		showConferenceForm() {
			this.syncModalScrollLock()
		},

		'$route.query.tab'(tab) {
			if (this.availableTabs.some(t => t.id === tab)) {
				this.activeTab = tab
			}
			this.ensureAllowedActiveTab()
		},

		// Отслеживание возврата из preview в Bitrix через изменение роута
		'$route'(to, from) {
			const isBitrix = localStorage.getItem('bitrix24_mode') === 'true'
			if (!isBitrix) return

			console.log('[Bitrix] Route changed:', {
				from: from.path,
				to: to.path,
				previewFlag: sessionStorage.getItem('bitrix_preview_opened')
			})

			// Проверяем возврат из preview
			const isFromPreview = from.path?.includes('/screen8-preview') || from.name === 'TeacherScreen8Preview'
			const isToEditPage = to.path?.includes('/courses/') && to.path?.includes('/edit')
			const wasInPreview = sessionStorage.getItem('bitrix_preview_opened') === 'true'

			console.log('[Bitrix] Route check:', { isFromPreview, isToEditPage, wasInPreview })

			if (isFromPreview && isToEditPage && wasInPreview) {
				console.log('[Bitrix] Возврат из preview обнаружен через route watch')
				sessionStorage.removeItem('bitrix_preview_opened')
				// Используем nextTick чтобы дождаться полной загрузки компонента
				this.$nextTick(() => {
					this.handleCloseEditingForm()
				})
			}
		},
	},

	computed: {
		resolvedRouteCourseId() {
			return this.routeCourseId ?? this.$route.params.id ?? null
		},

		routeIntentMode() {
			if (typeof this.routeMode === 'string' && this.routeMode.trim()) {
				return this.routeMode
			}

			return this.resolvedRouteCourseId ? 'edit' : 'create'
		},

		isAdminContext() {
			return this.$route.path.startsWith('/admin/')
		},

		availableTabs() {
			if (this.isAdminContext) {
				return this.tabs
			}
			return this.tabs.filter(tab => tab.id !== 'certificates')
		},

		isFromModuleView() {
			return this.$route.query?.from === 'module-view'
		},

		isFromTeacherCourse() {
			return this.$route.query?.from === 'teacher-course'
		},

		breadcrumbCourseName() {
			return this.courseTitle || 'Без названия'
		},

		breadcrumbModuleTitle() {
			return this.$route.query?.moduleTitle || 'Модуль'
		},

		createButtonText() {
			const buttonTextMap = {
				modules: 'Создать модуль',
				conferences: 'Создать конференцию',
				certificates: 'Создать сертификат',
				faq: 'Создать вопрос',
			}
			return buttonTextMap[this.activeTab] || 'Создать'
		},

		breadcrumbTitle() {
			if (!this.courseId) {
				return this.routeIntentMode === 'create'
					? 'Создание курса'
					: 'Редактирование курса'
			}
			const courseName = this.courseTitle || 'Без названия'
			const mode = this.isEditMode ? '(редактирование)' : '(создание)'
			return `Курс: ${courseName} ${mode}`
		},

		isCourseCreated() {
			return !!this.courseId
		},

		hasContent() {
			const contentMap = {
				modules: this.modules.length > 0,
				conferences: this.conferences.length > 0,
				certificates: this.certificates.length > 0,
				faq: this.faqs.length > 0,
			}
			return contentMap[this.activeTab] || false
		},

		shouldShowPlaceholder() {
			return (
				this.activeTab !== 'description' &&
				!this.showModuleCreation &&
				!this.hasContent
			)
		},

		customCategories() {
			const builtinIds = ['tech', 'sales', 'management', 'business']
			return this.categories.filter(
				category => !builtinIds.includes(category.id)
			)
		},

		publishedModules() {
			return this.modules.filter(m => !m.isDraft)
		},

		draftModules() {
			return this.modules.filter(m => m.isDraft)
		},

		hasPublishedModules() {
			return this.publishedModules.length > 0 || this.draftModules.length > 0
		},

		hasDraftModules() {
			return this.draftModules.length > 0
		},

		demoMediaTypeLabel() {
			if (this.demoMediaType === 'video') return 'Видео'
			if (this.demoMediaType === 'presentation') return 'Презентация'
			return this.demoMediaType || ''
		},
	},
	methods: {
		syncModalScrollLock() {
			const hasOpenModal = this.showFaqForm || this.showConferenceForm
			if (hasOpenModal) {
				this.lockBodyScroll()
			} else {
				this.unlockBodyScroll()
			}
		},

		lockBodyScroll() {
			if (typeof document === 'undefined' || this._isBodyScrollLocked) return

			this._prevBodyOverflow = document.body.style.overflow
			this._prevBodyPaddingRight = document.body.style.paddingRight

			const scrollbarWidth =
				window.innerWidth - document.documentElement.clientWidth

			document.body.style.overflow = 'hidden'
			if (scrollbarWidth > 0) {
				document.body.style.paddingRight = `${scrollbarWidth}px`
			}

			this._isBodyScrollLocked = true
		},

		unlockBodyScroll() {
			if (typeof document === 'undefined' || !this._isBodyScrollLocked) return

			document.body.style.overflow = this._prevBodyOverflow || ''
			document.body.style.paddingRight = this._prevBodyPaddingRight || ''

			this._prevBodyOverflow = ''
			this._prevBodyPaddingRight = ''
			this._isBodyScrollLocked = false
		},

		ensureAllowedActiveTab() {
			if (!this.availableTabs.some(tab => tab.id === this.activeTab)) {
				this.activeTab = 'description'
			}
		},

		// Показ уведомления
		showNotification(message, type = 'success', timeout = 3000) {
			if (this._notificationTimeoutId) {
				clearTimeout(this._notificationTimeoutId)
				this._notificationTimeoutId = null
			}

			this.notification.message = message
			this.notification.type = type
			this.notification.show = true

			this._notificationTimeoutId = setTimeout(() => {
				this.notification.show = false
				this._notificationTimeoutId = null
			}, timeout)
		},

		isExistingId(id) {
			const MAX_DB_ID = 2147483647
			return !!id && !String(id).startsWith('temp_') && Number(id) <= MAX_DB_ID
		},

		/**
		 * Загрузить данные курса для редактирования
		 */
		async loadCourse(courseId) {
			try {
				this.loading = true
				this.error = null

				const course = await coursesService.getById(courseId)

				this.courseId = course.id
				this.courseTitle = course.title || ''
				this.courseSubtitle = course.subtitle || ''
				this.courseDescription = course.description || ''
				this.courseShortDescription = course.short_description || ''
				this.selectedCategory = course.category || ''
				
				// Новые поля
				this.difficultyLevel = course.difficulty_level || ''
				this.durationHours = course.duration_hours || null
				this.price = course.price || 0
				this.maxStudents = course.max_students || null
				this.unlimitedStudents = !course.max_students
				this.isFree = course.is_free || false
				this.isPublished = course.is_published !== undefined ? course.is_published : true
				this.isHidden = course.is_hidden || false
				this.presentationAudience = course.presentation_audience || ''
				this.presentationFormat = course.presentation_format || ''
				this.presentationBenefits = course.presentation_benefits || ''
				this.presentationOutcome = course.presentation_outcome || ''
				this.demoMediaPath = course.demo_media_path || null
				this.demoMediaName = course.demo_media_name || ''
				this.demoMediaType = course.demo_media_type || ''

				if (
					this.selectedCategory &&
					!this.categories.some(
						category => category.id === this.selectedCategory
					)
				) {
					this.categories.push({
						id: this.selectedCategory,
						name: this.selectedCategory,
					})
				}

				this.courseTags = course.tags || []
				this.coverPreview = course.cover_image_url || course.cover_image || null

				await this.loadModules(courseId)
				await this.loadConferences()
				await this.loadCertificates()
				await this.loadFaqs()

				this.isEditMode = true
			} catch (error) {
				console.error('Ошибка при загрузке курса:', error)
				this.error = 'Не удалось загрузить данные курса'
				this.showNotification(
					'Ошибка при загрузке курса: ' + error.message,
					'error',
					6000
				)
			} finally {
				this.loading = false
			}
		},

		/**
		 * Загрузить модули курса из БД
		 */
		async loadModules(courseId) {
			try {
				console.log('Loading modules for course:', courseId)
				const rawModules = await modulesService.getByCourseId(courseId)
				console.log('Modules loaded:', rawModules)
				console.log('Response type:', typeof rawModules, Array.isArray(rawModules))

				const now = new Date()
				const syncJobs = []
				const formatPublishAt = date => {
					const day = String(date.getDate()).padStart(2, '0')
					const month = String(date.getMonth() + 1).padStart(2, '0')
					const year = date.getFullYear()
					const hours = String(date.getHours()).padStart(2, '0')
					const minutes = String(date.getMinutes()).padStart(2, '0')
					return `${day}-${month}-${year} ${hours}:${minutes}`
				}
				const formatDateForInfo = value => {
					if (!value || typeof value !== 'string') return ''
					const trimmed = value.trim()
					if (!trimmed) return ''
					if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
						const [year, month, day] = trimmed.split('-')
						return `${day}-${month}-${year}`
					}
					if (/^\d{2}\.\d{2}\.\d{4}$/.test(trimmed)) {
						const [day, month, year] = trimmed.split('.')
						return `${day}-${month}-${year}`
					}
					return trimmed
				}
				const parseTimePart = value => {
					if (!value || typeof value !== 'string') return null
					const parts = value.split(':')
					if (parts.length < 2) return null
					const hours = Number(parts[0])
					const minutes = Number(parts[1])
					const seconds = parts.length > 2 ? Number(parts[2]) : 0
					if (
						Number.isNaN(hours) ||
						Number.isNaN(minutes) ||
						Number.isNaN(seconds)
					) {
						return null
					}
					return { hours, minutes, seconds }
				}
				const parseDatePart = value => {
					if (!value || typeof value !== 'string') return null
					const trimmed = value.trim()
					if (!trimmed) return null
					if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
						const [year, month, day] = trimmed.split('-').map(Number)
						return { year, month, day }
					}
					if (/^\d{2}\.\d{2}\.\d{4}$/.test(trimmed)) {
						const [day, month, year] = trimmed.split('.').map(Number)
						return { year, month, day }
					}
					if (/^\d{2}-\d{2}-\d{4}$/.test(trimmed)) {
						const [day, month, year] = trimmed.split('-').map(Number)
						return { year, month, day }
					}
					return null
				}
				const buildDate = (datePart, timePart) => {
					const date = parseDatePart(datePart)
					if (!date) return null
					const time = parseTimePart(timePart) || {
						hours: 0,
						minutes: 0,
						seconds: 0,
					}
					return new Date(
						date.year,
						date.month - 1,
						date.day,
						time.hours,
						time.minutes,
						time.seconds
					)
				}
				const parseLocalDateTime = value => {
					if (typeof value === 'number') {
						const parsed = new Date(value)
						return Number.isNaN(parsed.getTime()) ? null : parsed
					}
					if (!value || typeof value !== 'string') return null
					const trimmed = value.trim()
					if (!trimmed) return null
					if (trimmed.includes('T')) {
						const parsed = new Date(trimmed)
						return Number.isNaN(parsed.getTime()) ? null : parsed
					}
					if (trimmed.includes(' ')) {
						const [datePart, timePart] = trimmed.split(' ')
						return buildDate(datePart, timePart)
					}
					return buildDate(trimmed, null)
				}

				this.modules = rawModules.map(module => {
					console.log('Module cover details:', {
						id: module.id,
						title: module.title,
						cover_image_raw: module.cover_image,
						cover_image_type: typeof module.cover_image,
						cover_image_is_empty_object:
							typeof module.cover_image === 'object' &&
							module.cover_image !== null &&
							Object.keys(module.cover_image).length === 0,
					})

					let coverImageUrl = null

					if (
						typeof module.cover_image === 'string' &&
						module.cover_image.trim()
					) {
						coverImageUrl = module.cover_image
					} else if (
						typeof module.cover_image === 'object' &&
						module.cover_image !== null &&
						!Array.isArray(module.cover_image)
					) {
						const keys = Object.keys(module.cover_image)
						if (keys.length > 0 && module.cover_image.url) {
							coverImageUrl = module.cover_image.url
						}
					}

					console.log('Selected cover URL:', coverImageUrl)

					const publishInfoRaw = module.publish_info || ''
					const publishedPrefix = '\u041e\u043f\u0443\u0431\u043b\u0438\u043a\u043e\u0432\u0430\u043d\u043e '
					const immediateLabel = '\u0421\u0440\u0430\u0437\u0443'
					const publishInfoTrimmed = publishInfoRaw.trim()
					const publishInfoLower = publishInfoTrimmed.toLowerCase()
					const publishInfoForParse = publishInfoLower.startsWith(
						publishedPrefix.toLowerCase()
					)
						? publishInfoTrimmed.slice(publishedPrefix.length).trim()
						: publishInfoTrimmed
					const rawPublishAt = module.publish_at || module.publishAt || null
					let publishDate = module.publish_date || null
					let publishTime = module.publish_time || null
					let publishAt = null

					if (
						publishDate &&
						(publishDate.includes('T') || publishDate.includes(' '))
					) {
						const parsed = parseLocalDateTime(publishDate)
						if (parsed) {
							const year = parsed.getFullYear()
							const month = String(parsed.getMonth() + 1).padStart(2, '0')
							const day = String(parsed.getDate()).padStart(2, '0')
							const hours = String(parsed.getHours()).padStart(2, '0')
							const minutes = String(parsed.getMinutes()).padStart(2, '0')
							publishDate = `${year}-${month}-${day}`
							if (!publishTime) {
								publishTime = `${hours}:${minutes}`
							}
						}
					}

					if (publishTime && typeof publishTime === 'string' && publishTime.length > 5) {
						publishTime = publishTime.slice(0, 5)
					}

					if (rawPublishAt) {
						const parsed = parseLocalDateTime(rawPublishAt)
						if (parsed) {
							publishAt = parsed
						}
					}
					if (!publishAt && publishDate && publishTime) {
						publishAt = buildDate(publishDate, publishTime)
					}
					if (
						!publishAt &&
						publishInfoForParse &&
						publishInfoForParse !== immediateLabel
					) {
						let parsedFromInfo = null
						if (publishInfoForParse.includes('T') && publishInfoForParse.includes(' ')) {
							const infoParts = publishInfoForParse.split(' ')
							const timeCandidate = infoParts[infoParts.length - 1]
							const timeParts = parseTimePart(timeCandidate)
							const dateCandidate = parseLocalDateTime(infoParts[0])
							if (dateCandidate && timeParts) {
								const year = dateCandidate.getFullYear()
								const month = String(dateCandidate.getMonth() + 1).padStart(2, '0')
								const day = String(dateCandidate.getDate()).padStart(2, '0')
								const hours = String(timeParts.hours).padStart(2, '0')
								const minutes = String(timeParts.minutes).padStart(2, '0')
								const infoDate = `${year}-${month}-${day}`
								const infoTime = `${hours}:${minutes}`
								if (!publishDate) {
									publishDate = infoDate
								}
								if (!publishTime) {
									publishTime = infoTime
								}
								parsedFromInfo = buildDate(infoDate, infoTime)
							}
						}
						if (!parsedFromInfo) {
							parsedFromInfo = parseLocalDateTime(publishInfoForParse)
						}
						if (parsedFromInfo) {
							publishAt = parsedFromInfo
							if (!publishDate || !publishTime) {
								const year = publishAt.getFullYear()
								const month = String(publishAt.getMonth() + 1).padStart(2, '0')
								const day = String(publishAt.getDate()).padStart(2, '0')
								const hours = String(publishAt.getHours()).padStart(2, '0')
								const minutes = String(publishAt.getMinutes()).padStart(2, '0')
								if (!publishDate) {
									publishDate = `${year}-${month}-${day}`
								}
								if (!publishTime) {
									publishTime = `${hours}:${minutes}`
								}
							}
						}
					}
					if (publishAt) {
						const year = publishAt.getFullYear()
						const month = String(publishAt.getMonth() + 1).padStart(2, '0')
						const day = String(publishAt.getDate()).padStart(2, '0')
						const hours = String(publishAt.getHours()).padStart(2, '0')
						const minutes = String(publishAt.getMinutes()).padStart(2, '0')
						if (!publishDate) {
							publishDate = `${year}-${month}-${day}`
						}
						if (!publishTime) {
							publishTime = `${hours}:${minutes}`
						}
					}

					const hasSchedule =
						module.publish_type === 'scheduled' ||
						!!publishAt ||
						(!!publishDate && !!publishTime) ||
						!!rawPublishAt
					const beforePublish =
						publishAt ? publishAt.getTime() > now.getTime() : false
					const afterPublish =
						publishAt ? publishAt.getTime() <= now.getTime() : false
					const backendHidden =
						typeof module.is_hidden === 'boolean' ? module.is_hidden : null
					let isHidden = backendHidden ?? false
					
					// Если есть расписание и время ещё не наступило - скрываем автоматически
					if (hasSchedule && publishAt && beforePublish) {
						isHidden = true
					}
					// Если время наступило, но backendHidden явно установлен - используем его
					// Иначе показываем модуль
					else if (hasSchedule && publishAt && afterPublish) {
						isHidden = backendHidden ?? false
					}
					const isPublished = (module.is_published ?? false) || hasSchedule
					const isDraft =
						!isPublished && !hasSchedule ? module.is_draft ?? true : false

					if (hasSchedule && publishAt) {
						if (beforePublish) {
							const needsHideSync =
								module.is_hidden !== true ||
								module.is_draft ||
								!module.is_published
							if (needsHideSync) {
								syncJobs.push(this.syncScheduledModuleState(module.id, true))
							}
						} else {
							const needsPublishSync =
								module.is_draft || !module.is_published || module.is_hidden === true
							if (needsPublishSync) {
								syncJobs.push(this.syncScheduledModuleState(module.id, false))
							}
						}
					}

					let publishInfo = publishInfoRaw
					if (hasSchedule && publishAt && afterPublish) {
						publishInfo = `${publishedPrefix}${formatPublishAt(publishAt)}`
					} else if (hasSchedule && publishAt) {
						const publishDateForInfo = formatDateForInfo(publishDate)
						if (publishDateForInfo && publishTime) {
							publishInfo = `${publishDateForInfo} ${publishTime}`
						}
					}
					if (!publishInfo) {
						publishInfo = immediateLabel
					}

					return {
						id: module.id,
						title: module.title,
						subtitle: module.subtitle || '',
						description: module.description || '',
						duration_hours: module.duration_hours ?? null,
						coverImage: coverImageUrl,
						publishType:
							module.publish_type || (hasSchedule ? 'scheduled' : 'immediate'),
						publishDate,
						publishTime,
						publishInfo,
						isDraft,
						is_draft: isDraft,
						isHidden,
						is_hidden: isHidden,
						isPublished,
						is_published: isPublished,
						completion_policy:
							module.completion_policy ?? module.completionPolicy ?? null,
						completionPolicy:
							module.completion_policy ?? module.completionPolicy ?? null,
						elements: module.elements || {},
					}
				})

				if (syncJobs.length) {
					await Promise.allSettled(syncJobs)
				}

				console.log('Модули нормализованы:', this.modules)
				console.log('Количество модулей:', this.modules.length)
			} catch (error) {
				console.error('Ошибка при загрузке модулей:', error)
				this.modules = []
				this.showNotification(
					'Ошибка при загрузке модулей: ' + error.message,
					'error',
					6000
				)
			}
		},
		async syncScheduledModuleState(moduleId, keepHidden) {
			if (!moduleId || String(moduleId).startsWith('temp_')) return
			try {
				await modulesService.update(moduleId, {
					is_hidden: keepHidden,
					is_published: true,
					is_draft: false,
				})
			} catch (error) {
				console.warn('Не удалось синхронизировать автопубликацию модуля:', error)
			}
		},

		async loadCertificates() {
			if (!this.courseId) return

			this.certificatesLoading = true
			try {
				const response = await certificatesService.getByCourseId(this.courseId)
				this.certificates = this.normalizeCertificatesResponse(response)
			} catch (error) {
				// 404 трактуем как "нет шаблонов" без ошибок в консоли
				if (error.response?.status === 404) {
					this.certificates = []
				} else {
					console.error('Не удалось загрузить сертификаты:', error)
					this.certificates = []
					this.showNotification('Ошибка загрузки сертификатов', 'error')
				}
			} finally {
				this.certificatesLoading = false
			}
		},

		normalizeCertificatesResponse(data) {
			// Если пришёл одиночный объект - оборачиваем в массив
			if (data && typeof data === 'object' && !Array.isArray(data) && data.id) {
				return [data]
			}

			if (Array.isArray(data)) return data
			if (Array.isArray(data?.data)) return data.data
			if (Array.isArray(data?.certificates)) return data.certificates

			return []
		},

		/**
		 * Создание сертификата (вызывается из CertificatesManager)
		 */
		async handleCreateCertificate(payload) {
			if (!this.courseId) {
				this.showNotification('Сначала создайте курс', 'error', 5000)
				return
			}

			try {
				// payload.template_data уже содержит JSON строку с layers, backgroundColor и т.д.
				// payload.criteria - JSON строка с массивом критериев
				const criteria = payload.criteria 
					? (typeof payload.criteria === 'string' ? JSON.parse(payload.criteria) : payload.criteria)
					: ['Завершить курс']
				
				const apiData = {
					template_name: payload.template_name,
					template_data: {
						content: payload.template_data,
						criteria: criteria,
					},
					preview_image: payload.preview_image || null,
					is_active: true,
				}

				await certificatesService.create(this.courseId, apiData)
				await this.loadCertificates()
				this.showNotification('Шаблон сертификата создан', 'success')
			} catch (error) {
				console.error('Failed to create certificate:', error)
				this.showNotification('Не удалось создать шаблон сертификата', 'error')
			}
		},

		/**
		 * Обновление сертификата (вызывается из CertificatesManager)
		 */
		async handleUpdateCertificate(payload) {
			if (!payload.id) {
				this.showNotification('Ошибка: ID сертификата не указан', 'error')
				return
			}

			try {
				// payload.template_data уже содержит JSON строку с layers, backgroundColor и т.д.
				// payload.criteria - JSON строка с массивом критериев
				const criteria = payload.criteria 
					? (typeof payload.criteria === 'string' ? JSON.parse(payload.criteria) : payload.criteria)
					: ['Завершить курс']
				
				const apiData = {
					template_name: payload.template_name,
					template_data: {
						content: payload.template_data,
						criteria: criteria,
					},
					preview_image: payload.preview_image || null,
					is_active: true,
				}

				await certificatesService.update(payload.id, apiData)
				await this.loadCertificates()
				this.showNotification('Шаблон сертификата обновлён', 'success')
			} catch (error) {
				console.error('Failed to update certificate:', error)
				this.showNotification('Не удалось обновить шаблон сертификата', 'error')
			}
		},

		/**
		 * Удаление сертификата (вызывается из CertificatesManager)
		 */
		async handleDeleteCertificate(certificate) {
			try {
				await certificatesService.delete(certificate.id)
				await this.loadCertificates()
				this.showNotification('Шаблон сертификата удалён', 'success')
			} catch (error) {
				console.error('Failed to delete certificate:', error)
				this.showNotification('Не удалось удалить шаблон сертификата', 'error')
			}
		},

		/**
		 * Обработка ошибок из CertificatesManager
		 */
		handleCertificateError(message) {
			this.showNotification(message, 'error')
		},

		// ========== FAQ METHODS ==========
		async loadFaqs() {
			if (!this.courseId) return

			this.faqsLoading = true
			try {
				const response = await faqService.getByCourseId(this.courseId)
				this.faqs = this.normalizeFaqsResponse(response)
				console.log('✅ FAQ загружены:', this.faqs.length)
			} catch (error) {
				console.error('Не удалось загрузить FAQ:', error)
				this.faqs = []
			} finally {
				this.faqsLoading = false
			}
		},

		normalizeFaqsResponse(data) {
			if (Array.isArray(data)) return data
			if (Array.isArray(data?.data)) return data.data
			if (Array.isArray(data?.faqs)) return data.faqs
			if (Array.isArray(data?.faq)) return data.faq
			return []
		},

		openFaqForm(faq = null) {
			this.selectedFaq = faq
			this.showFaqForm = true
			this.$nextTick(() => {
				const firstInput = this.$refs.faqForm?.$el?.querySelector(
					'input, select, textarea, button'
				)
				firstInput?.focus()
			})
		},

		closeFaqForm() {
			this.showFaqForm = false
			this.selectedFaq = null
		},

		handleEditFaq(faq) {
			this.openFaqForm(faq)
		},

		async handleDeleteFaq(faq) {
			try {
				await faqService.delete(faq.id)
				await this.loadFaqs()
				this.showNotification('Вопрос удалён', 'success')
			} catch (error) {
				console.error('Failed to delete FAQ:', error)
				this.showNotification('Не удалось удалить вопрос', 'error')
			}
		},

		async handleToggleFaqPublish(faq) {
			try {
				if (faq.is_published) {
					await faqService.unpublish(faq.id)
					this.showNotification('Вопрос снят с публикации', 'success')
				} else {
					await faqService.publish(faq.id)
					this.showNotification('Вопрос опубликован', 'success')
				}
				await this.loadFaqs()
			} catch (error) {
				console.error('Failed to toggle FAQ publish:', error)
				this.showNotification('Не удалось изменить статус публикации', 'error')
			}
		},

		async handleReorderFaqs(faqIds) {
			try {
				await faqService.reorder(this.courseId, faqIds)
				console.log('✅ Порядок FAQ обновлён')
			} catch (error) {
				console.error('Failed to reorder FAQs:', error)
				this.showNotification('Не удалось изменить порядок вопросов', 'error')
				await this.loadFaqs()
			}
		},

		async handleFaqSubmit(faqData) {
			// Защита от двойного клика
			if (this.savingFaq) return

			if (!this.courseId) {
				this.showNotification('Сначала создайте курс', 'error', 5000)
				return
			}

			this.savingFaq = true

			try {
				const apiData = {
					question: faqData.question,
					answer: faqData.answer,
					is_published: !!faqData.is_published,
				}

				if (this.selectedFaq && this.selectedFaq.id > 0) {
					await faqService.update(this.selectedFaq.id, apiData)
					this.showNotification('Вопрос обновлён', 'success')
				} else {
					await faqService.create(this.courseId, apiData)
					this.showNotification('Вопрос создан', 'success')
				}

				await this.loadFaqs()
				this.closeFaqForm()
			} catch (error) {
				console.error('Failed to save FAQ:', error)
				this.showNotification('Не удалось сохранить вопрос', 'error')
			} finally {
				this.savingFaq = false
			}
		},

		// ========== MODULE EDITING LOCK ==========
		isModuleEditingLocked(showMessage = false) {
			// Если идёт logout - не блокируем
			if (authState.isLoggingOut) {
				return false
			}

			const moduleEditor = this.$refs.courseCreationPage
			const isEditingModule = moduleEditor?.showCreationForm

			if (!isEditingModule) {
				return false
			}

			const hasChanges = moduleEditor?.isModified

			if (showMessage) {
				const message = hasChanges
					? 'Завершите редактирование модуля: сохраните изменения или выйдите из режима редактирования.'
					: 'Закройте режим редактирования модуля, чтобы продолжить навигацию.'

				this.showNotification(message, 'error', 4000)
			}

			return true
		},

		// ✅ Проверка logout-маршрута
		isLogoutRoute(to) {
			if (!to) return false

			const path = (to.path || '').toLowerCase()
			const name = (to.name || '').toLowerCase()

			const authPaths = ['/auth', '/login', '/logout', '/signin', '/signout']
			const authNames = ['auth', 'login', 'logout', 'signin', 'signout']

			const isAuthPath = authPaths.some(p => path.startsWith(p))
			const isAuthName = authNames.includes(name)
			const isGuestOnly = !!(to.meta && to.meta.guestOnly)

			return isAuthPath || isAuthName || isGuestOnly
		},

		// ✅ Принудительное закрытие редактора модуля
		forceCloseModuleEditor() {
			const moduleEditor = this.$refs.courseCreationPage
			if (moduleEditor) {
				moduleEditor.closeEditingSession?.()
				moduleEditor.showCreationForm = false
			}
			this.showModuleCreation = false
			this.autoOpenModuleForm = false
			this.editingModuleId = null
		},

		// ✅ Обработчик события logout
		handleAuthLogout() {
			console.log('🔐 [CreateCourse] Received auth:logout event')
			if (!authState.isLoggingOut) {
				authState.startLogout()
			}
			this.forceCloseModuleEditor()
			this.resetForm()
			this.unlockBodyScroll()
			this.clearCreateCourseStorage()
		},

		// Breadcrumb Navigation
		navigateToHome() {
			if (this.isModuleEditingLocked(true)) {
				return
			}

			this.$router.push('/teacher/dashboard')
		},

		navigateToMyCourses() {
			if (this.isModuleEditingLocked(true)) {
				return
			}

			this.$router.push('/teacher/dashboard').then(() => {
				this.$nextTick(() => {
					setTimeout(() => {
						const element = document.getElementById('teacher-courses')
						if (element) {
							element.scrollIntoView({
								behavior: 'smooth',
								block: 'start',
							})
						}
					}, 100)
				})
			})
		},

		navigateToModuleView() {
			if (this.isModuleEditingLocked(true)) {
				return
			}

			if (!this.courseId) return
			const moduleId = this.$route.query?.moduleId
			if (!moduleId) return
			this.$router.push({
				path: `/teacher/courses/${this.courseId}/modules`,
				query: { moduleId },
			})
		},

		navigateToCourse() {
			if (this.isModuleEditingLocked(true)) {
				return
			}

			if (!this.courseId) return
			this.$router.push(`/teacher/courses/${this.courseId}`)
		},

		// Navigation
		goBack() {
			if (this.isModuleEditingLocked(true)) {
				return
			}

			this.$router.push('/teacher/dashboard')
		},

		// Cover upload handler
		handleUploadCover() {
			const input = document.createElement('input')
			input.type = 'file'
			input.accept = 'image/*'
			input.onchange = async e => {
				const file = e.target.files[0]
				if (!file) return

				if (file.size > 5 * 1024 * 1024) {
					this.showNotification(
						'Размер файла не должен превышать 5MB',
						'error',
						5000
					)
					return
				}

				if (!file.type.startsWith('image/')) {
					this.showNotification(
						'Пожалуйста, выберите файл изображения',
						'error',
						5000
					)
					return
				}

				this.coverFile = file

				const reader = new FileReader()
				reader.onload = e => {
					this.coverPreview = e.target.result
				}
				reader.readAsDataURL(file)

				if (this.courseId) {
					await this.uploadCover()
				}
			}
			input.click()
		},

		/**
		 * Загрузить обложку на сервер
		 */
		async uploadCover() {
			if (!this.coverFile || !this.courseId) return

			try {
				this.saving = true
				const result = await coursesService.uploadCover(
					this.courseId,
					this.coverFile
				)
				console.log('Обложка загружена:', result)

				if (result.data && result.data.cover_image_url) {
					this.coverPreview = result.data.cover_image_url
					console.log('✅ URL обложки обновлен:', this.coverPreview)

					this.saveCourseToLocalStorage()
					eventBus.emit('course-updated', this.courseId)
				}

				this.showNotification('Обложка успешно загружена!', 'success')
			} catch (error) {
				console.error('Ошибка при загрузке обложки:', error)
				this.showNotification(
					'Ошибка при загрузке обложки: ' + error.message,
					'error',
					6000
				)
			} finally {
				this.saving = false
			}
		},

		// Demo media upload handler (video or PPTX)
		handleUploadDemoMedia() {
			const input = document.createElement('input')
			input.type = 'file'
			input.accept = 'video/*,.ppt,.pptx'
			input.onchange = async e => {
				const file = e.target.files[0]
				if (!file) return

				const ext = `.${file.name.split('.').pop().toLowerCase()}`
				const videoExts = ['.mp4', '.webm', '.ogv', '.avi', '.mov', '.mkv']
				const pptExts = ['.ppt', '.pptx', '.pptm', '.pps', '.ppsx']
				const isVideo = file.type.startsWith('video/') || videoExts.includes(ext)
				const isPresentation = pptExts.includes(ext)

				if (!isVideo && !isPresentation) {
					this.showNotification(
						'Разрешены только видео или презентации PPTX',
						'error',
						5000
					)
					return
				}

				const maxSize = isVideo ? 500 * 1024 * 1024 : 50 * 1024 * 1024
				if (file.size > maxSize) {
					this.showNotification(
						isVideo
							? 'Размер видео не должен превышать 500MB'
							: 'Размер презентации не должен превышать 50MB',
						'error',
						5000
					)
					return
				}

				this.demoMediaFile = file
				this.demoMediaName = file.name
				this.demoMediaType = isVideo ? 'video' : 'presentation'
				this.demoMediaPath = null

				if (this.courseId) {
					await this.uploadDemoMedia()
				}
			}
			input.click()
		},

		/**
		 * Загрузить демо файл на сервер
		 */
		async uploadDemoMedia() {
			if (!this.demoMediaFile || !this.courseId) return

			try {
				this.saving = true
				const result = await coursesService.uploadDemoMedia(
					this.courseId,
					this.demoMediaFile
				)
				const updated = result?.data || result

				if (updated?.demo_media_path) {
					this.demoMediaPath = updated.demo_media_path
					this.demoMediaName = updated.demo_media_name || this.demoMediaName
					this.demoMediaType = updated.demo_media_type || this.demoMediaType
					this.saveCourseToLocalStorage()
					eventBus.emit('course-updated', this.courseId)
				}

				this.showNotification('Демо файл успешно загружен!', 'success')
			} catch (error) {
				console.error('Ошибка при загрузке демо файла:', error)
				this.showNotification(
					'Ошибка при загрузке демо файла: ' + error.message,
					'error',
					6000
				)
			} finally {
				this.saving = false
			}
		},

		// Input handlers
		handleTitleChange() {
			this.$emit('title-changed', this.courseTitle)
		},

		handleSubtitleChange() {
			this.$emit('subtitle-changed', this.courseSubtitle)
		},

		handleDescriptionChange: debounce(function () {
			this.$emit('description-changed', this.courseDescription)
			this.autoSaveDraft()
		}, 500),

		autoSaveDraft() {
			this.saveCourseToLocalStorage()
		},

		handleCategoryChange() {
			this.$emit('category-changed', this.selectedCategory)
		},

		handleCustomCategoryInput() {
			if (this.categoryValidationError) {
				this.categoryValidationError = ''
			}
		},

		handleAddCustomCategory() {
			this.categoryValidationError = ''

			const name = (this.newCategoryName || '').trim()

			if (!name) {
				this.categoryValidationError = 'Введите название категории'
				return
			}

			if (name.length < 3) {
				this.categoryValidationError =
					'Название категории должно содержать не менее 3 символов'
				return
			}

			const validCharsPattern = /^[А-Яа-яЁёA-Za-z0-9\s-]+$/

			if (!validCharsPattern.test(name)) {
				this.categoryValidationError =
					'Название категории может содержать только буквы, цифры, пробелы и дефис'
				return
			}

			const exists = this.categories.some(
				category => category.name.toLowerCase() === name.toLowerCase()
			)

			if (exists) {
				this.categoryValidationError = 'Такая категория уже существует'
				return
			}

			const newCategory = {
				id: name,
				name,
			}

			this.categories.push(newCategory)
			this.selectedCategory = newCategory.id
			this.handleCategoryChange()
			this.newCategoryName = ''
		},

		handleRemoveCustomCategory(categoryId) {
			const builtinIds = ['tech', 'sales', 'management', 'business']

			if (builtinIds.includes(categoryId)) {
				return
			}

			this.categories = this.categories.filter(
				category => category.id !== categoryId
			)

			if (this.selectedCategory === categoryId) {
				this.selectedCategory = ''
				this.handleCategoryChange()
			}
		},
		
		handleUnlimitedToggle() {
			if (this.unlimitedStudents) {
				this.maxStudents = null
			}
		},

		// Tab navigation
		handleTabChange(tabId) {
			if (this.isModuleEditingLocked(true)) {
				return
			}

			if (this.isTabDisabled(tabId)) {
				return
			}
			this.activeTab = tabId
			this.$emit('tab-changed', tabId)
		},

		// Определяет, должна ли вкладка быть заблокирована
		isTabDisabled(tabId) {
			if (tabId === 'description') {
				return false
			}
			return !this.isCourseCreated
		},

		// Tags management
		handleAddTag() {
			if (this.newTag.trim() !== '') {
				this.courseTags.push(this.newTag.trim())
				this.newTag = ''
				this.$emit('tags-changed', this.courseTags)
			}
		},

		handleRemoveTag(index) {
			this.courseTags.splice(index, 1)
			this.$emit('tags-changed', this.courseTags)
		},

		// Form actions
		handleCancel(skipConfirmation = false) {
			if (skipConfirmation || authState.isLoggingOut) {
				this.resetForm()
				this.$router.push('/teacher/dashboard')
				return
			}

			const message = this.courseId
				? 'Вы уверены, что хотите отменить редактирование? Все несохраненные данные будут потеряны.'
				: 'Вы уверены, что хотите отменить создание курса? Все несохраненные данные будут потеряны.'

			if (confirm(message)) {
				this.resetForm()
				this.$router.push('/teacher/dashboard')
			}
		},

		async handleSave() {
			if (!this.courseTitle.trim()) {
				this.showNotification(
					'Пожалуйста, введите заголовок курса',
					'error',
					5000
				)
				return
			}

			if (!this.courseDescription.trim()) {
				this.showNotification(
					'Пожалуйста, введите описание курса',
					'error',
					5000
				)
				return
			}

			if (!this.selectedCategory) {
				this.showNotification(
					'Пожалуйста, выберите категорию курса',
					'error',
					5000
				)
				return
			}

			try {
				this.saving = true
				this.error = null

				const courseData = {
					title: this.courseTitle,
					subtitle: this.courseSubtitle,
					description: this.courseDescription,
					short_description: this.courseShortDescription,
					category: this.selectedCategory,
					tags: this.courseTags,
					difficulty_level: this.difficultyLevel || null,
					duration_hours: this.durationHours || null,
					price: this.price || 0,
					max_students: this.maxStudents || null,
					is_free: this.isFree,
					is_published: this.isPublished,
					is_hidden: this.isHidden,
					presentation_audience: this.presentationAudience || '',
					presentation_format: this.presentationFormat || '',
					presentation_benefits: this.presentationBenefits || '',
					presentation_outcome: this.presentationOutcome || '',
				}

				let result

				if (this.courseId) {
					result = await coursesService.update(this.courseId, courseData)
					console.log('Курс обновлен:', result)

					this.saveCourseToLocalStorage()
					eventBus.emit('course-updated', this.courseId)
					this.isEditMode = true

					this.showNotification('Курс успешно обновлён!', 'success')
				} else {
					result = await coursesService.create(courseData)
					this.courseId = result.id
					console.log('Курс создан:', result)

					if (this.coverFile) {
						await this.uploadCover()
					} else {
						this.saveCourseToLocalStorage()
						eventBus.emit('course-created', this.courseId)
					}

					if (this.demoMediaFile) {
						await this.uploadDemoMedia()
					}

					this.showNotification('Курс успешно создан!', 'success')
					const query = this.$route.query?.from
						? { from: this.$route.query.from }
						: {}
					this.$router.replace({
						path: `/teacher/courses/${this.courseId}/content`,
						query,
					})
				}

				this.$emit('save', result)
			} catch (error) {
				console.error('Ошибка при сохранении курса:', error)
				this.error = error.message
				this.showNotification(
					'Ошибка при сохранении курса: ' + error.message,
					'error',
					6000
				)
			} finally {
				this.saving = false
			}
		},

		// Обработчик создания элемента для заглушки
		handleCreateItem() {
			console.log(`Создание элемента для вкладки: ${this.activeTab}`)

			if (this.activeTab === 'modules') {
				this.showModuleCreation = true
				this.autoOpenModuleForm = true
			}

			this.$emit('create-item', this.activeTab)
		},

		// Обработчик события открытия формы модуля
		handleModuleFormOpened() {
			this.showModuleCreation = true
			this.autoOpenModuleForm = false
		},

		// Обработчики для модуля
		async handleSaveModule(moduleData) {
			const notifySaveError = error => {
				if (typeof moduleData?.__onSaveError === 'function') {
					moduleData.__onSaveError(error)
				}
			}
			const notifySaveSuccess = result => {
				if (typeof moduleData?.__onSaveSuccess === 'function') {
					moduleData.__onSaveSuccess(result)
				}
			}
			const isAutoSync = moduleData?.__autoSync === true
			const isSilent = moduleData?.__silent === true
			const keepEditorOpen = moduleData?.__keepEditorOpen === true
			if (this.saving) {
				const inProgressError = new Error('Сохранение модуля уже выполняется')
				if (isAutoSync) {
					notifySaveSuccess({ skipped: true, reason: 'save_in_progress' })
					return
				}
				if (!isSilent) {
					this.showNotification(
						'Сохранение уже выполняется. Дождитесь завершения текущей операции.',
						'warning',
						3000
					)
				}
				notifySaveError(inProgressError)
				return
			}

			if (!this.courseId) {
				if (!isSilent) {
					this.showNotification('Сначала создайте курс', 'error', 5000)
				}
				notifySaveError(new Error('Course ID is missing'))
				return
			}
			try {
				this.saving = true
				const isEditing = this.isExistingId(moduleData.id)

				const hasSchedule = moduleData.publishType === 'scheduled'
				const publishDate = hasSchedule ? moduleData.publishDate || null : null
				const publishTime = hasSchedule ? moduleData.publishTime || null : null
				const isPublished =
					moduleData.publishType === 'immediate' || hasSchedule
				const isDraft = !isPublished
				let isHidden = !!moduleData.isHidden
				if (hasSchedule) {
					const publishAt =
						publishDate && publishTime
							? new Date(`${publishDate}T${publishTime}`)
							: null
					if (publishAt && !Number.isNaN(publishAt.getTime())) {
						isHidden = publishAt.getTime() > Date.now()
					} else {
						isHidden = true
					}
				}
				const coverImageFile = moduleData.coverImage

				const apiData = {
					title: moduleData.title,
					subtitle: moduleData.subtitle || '',
					description: moduleData.description || '',
					duration_hours:
						moduleData.duration_hours ??
						moduleData.durationHours ??
						moduleData.moduleDuration ??
						null,
					completion_policy:
						moduleData.completion_policy ??
						moduleData.completionPolicy ??
						null,
					publish_type: moduleData.publishType || 'immediate',
					publish_date: publishDate,
					publish_time: publishTime,
					publish_info: moduleData.publishInfo || 'Сразу',
					is_published: isPublished,
					is_draft: isDraft,
					is_hidden: isHidden,
				}

				const normalizeNullable = value =>
					value === undefined || value === '' ? null : value
				const normalizeNumberOrNull = value => {
					if (value === undefined || value === null || value === '') return null
					const num = Number(value)
					return Number.isFinite(num) ? num : null
				}
				const normalizePolicy = policy => {
					if (policy === undefined || policy === null || policy === '') return null
					if (typeof policy === 'string') {
						const trimmed = policy.trim()
						if (!trimmed) return null
						try {
							return JSON.stringify(JSON.parse(trimmed))
						} catch {
							return trimmed
						}
					}
					try {
						return JSON.stringify(policy)
					} catch {
						return String(policy)
					}
				}

				let shouldUpdateModuleMeta = true
				if (isEditing) {
					const existingModule = this.modules.find(
						module => String(module.id) === String(moduleData.id)
					)
					const forceSkipAutoSyncUpdate =
						isAutoSync && moduleData?.__syncReason === 'material-update'
					const hasCoverChanges = coverImageFile instanceof File

					let moduleMetaChanged = true
					if (existingModule) {
						moduleMetaChanged =
							String(existingModule.title || '') !== String(apiData.title || '') ||
							String(existingModule.subtitle || '') !==
								String(apiData.subtitle || '') ||
							String(existingModule.description || '') !==
								String(apiData.description || '') ||
							normalizeNumberOrNull(existingModule.duration_hours) !==
								normalizeNumberOrNull(apiData.duration_hours) ||
							String(
								existingModule.publishType ||
									existingModule.publish_type ||
									'immediate'
							) !== String(apiData.publish_type || 'immediate') ||
							normalizeNullable(existingModule.publishDate || existingModule.publish_date) !==
								normalizeNullable(apiData.publish_date) ||
							normalizeNullable(existingModule.publishTime || existingModule.publish_time) !==
								normalizeNullable(apiData.publish_time) ||
							Boolean(existingModule.is_hidden) !== Boolean(apiData.is_hidden) ||
							Boolean(existingModule.is_published) !== Boolean(apiData.is_published) ||
							Boolean(existingModule.is_draft) !== Boolean(apiData.is_draft) ||
							normalizePolicy(
								existingModule.completion_policy ??
									existingModule.completionPolicy ??
									null
							) !== normalizePolicy(apiData.completion_policy)
					}

					shouldUpdateModuleMeta =
						!forceSkipAutoSyncUpdate && (moduleMetaChanged || hasCoverChanges)
				}

				let result
				if (isEditing) {
					if (shouldUpdateModuleMeta) {
						result = await modulesService.update(moduleData.id, apiData)
					} else {
						result = { id: moduleData.id, data: { id: moduleData.id } }
					}

					if (coverImageFile instanceof File) {
						await modulesService.uploadCover(moduleData.id, coverImageFile)
					}
				} else {
					result = await modulesService.create(this.courseId, apiData)

					if (coverImageFile instanceof File && result.id) {
						await modulesService.uploadCover(result.id, coverImageFile)
					}
				}

				if (!isEditing) {
					this.autoOpenModuleForm = false
				}

				// 🗑️ Удаляем элементы из БД, если они были помечены на удаление
				if (moduleData.deletedElements) {
					await this.deleteElementsFromDB(moduleData.deletedElements)
				}

				// ✅ Сохраняем материалы модуля
				if (moduleData.elements && result.id) {
					await this.saveLocalMaterialsToDB(result.id, moduleData.elements)
				}

				if (isEditing) {
					if (!keepEditorOpen) {
						this.showModuleCreation = false
						this.editingModuleId = null
					} else {
						this.showModuleCreation = true
						this.editingModuleId = result.id || moduleData.id || null
					}
				} else {
					this.showModuleCreation = true
					this.editingModuleId = result.id || null
				}

				if (!isAutoSync) {
					await this.loadModules(this.courseId)
				}

				if (!isSilent) {
					this.showNotification(
						isEditing ? 'Модуль успешно обновлён!' : 'Модуль успешно создан!',
						'success'
					)
				}
				notifySaveSuccess(result)
			} catch (error) {
				notifySaveError(error)
				console.error('Ошибка при сохранении модуля:', error)
				if (!isSilent) {
					this.showNotification(
						'Ошибка при сохранении модуля: ' + error.message,
						'error',
						6000
					)
				}
			} finally {
				this.saving = false
			}
		},

		async handleSaveDraft(draftData) {
			const notifySaveError = error => {
				if (typeof draftData?.__onSaveError === 'function') {
					draftData.__onSaveError(error)
				}
			}
			const notifySaveSuccess = result => {
				if (typeof draftData?.__onSaveSuccess === 'function') {
					draftData.__onSaveSuccess(result)
				}
			}
			if (this.saving) {
				const inProgressError = new Error('Сохранение модуля уже выполняется')
				this.showNotification(
					'Сохранение уже выполняется. Дождитесь завершения текущей операции.',
					'warning',
					3000
				)
				notifySaveError(inProgressError)
				return
			}

			if (!this.courseId) {
				this.showNotification('Сначала создайте курс', 'error', 5000)
				notifySaveError(new Error('Course ID is missing'))
				return
			}
			try {
				this.saving = true
				const isEditing = this.isExistingId(draftData.id)
				const coverImageFile = draftData.coverImage

				const apiData = {
					title: draftData.title,
					subtitle: draftData.subtitle || '',
					description: draftData.description || '',
					duration_hours:
						draftData.duration_hours ??
						draftData.durationHours ??
						draftData.moduleDuration ??
						null,
					completion_policy:
						draftData.completion_policy ??
						draftData.completionPolicy ??
						null,
					publish_type: draftData.publishType || 'immediate',
					publish_date: draftData.publishDate || null,
					publish_time: draftData.publishTime || null,
					publish_info: draftData.publishInfo || 'Сразу',
					is_published: false,
					is_draft: true,
					is_hidden: draftData.isHidden || false,
				}

				let result
				if (isEditing) {
					result = await modulesService.update(draftData.id, apiData)

					if (coverImageFile instanceof File) {
						await modulesService.uploadCover(draftData.id, coverImageFile)
					}
				} else {
					result = await modulesService.create(this.courseId, apiData)

					if (coverImageFile instanceof File && result.id) {
						await modulesService.uploadCover(result.id, coverImageFile)
					}
				}

				// 🗑️ Удаляем элементы из БД
				if (draftData.deletedElements) {
					await this.deleteElementsFromDB(draftData.deletedElements)
				}

				// ✅ Сохраняем материалы черновика
				if (draftData.elements && result.id) {
					await this.saveLocalMaterialsToDB(result.id, draftData.elements)
				}

				this.showModuleCreation = false
				this.editingModuleId = null

				await this.loadModules(this.courseId)

				this.showNotification(
					isEditing ? 'Черновик обновлён!' : 'Черновик сохранён!',
					'success'
				)
				notifySaveSuccess(result)
			} catch (error) {
				notifySaveError(error)
				console.error('Ошибка при сохранении черновика:', error)
				this.showNotification(
					'Ошибка при сохранении черновика: ' + error.message,
					'error',
					6000
				)
			} finally {
				this.saving = false
			}
		},

		/**
		 * Удаление элементов из БД
		 */
		async deleteElementsFromDB(deletedElements) {
			const {
				lessonsService,
				testsService,
				practicalService,
				homeworkService,
			} = await import('@/services')

			// Удаляем уроки
			if (deletedElements.lessons?.length > 0) {
				for (const id of deletedElements.lessons) {
					try {
						console.log('🗑️ Удаление урока из БД:', id)
						await lessonsService.delete(id)
						console.log('✅ Урок удален:', id)
					} catch (error) {
						console.error('❌ Ошибка удаления урока:', id, error)
					}
				}
			}

			// Удаляем тесты
			if (deletedElements.tests?.length > 0) {
				for (const id of deletedElements.tests) {
					try {
						console.log('🗑️ Удаление теста из БД:', id)
						await testsService.delete(id)
						console.log('✅ Тест удален:', id)
					} catch (error) {
						console.error('❌ Ошибка удаления теста:', id, error)
					}
				}
			}

			// Удаляем практические задания
			if (deletedElements.practice?.length > 0) {
				for (const id of deletedElements.practice) {
					try {
						console.log('🗑️ Удаление практического задания из БД:', id)
						await practicalService.delete(id)
						console.log('✅ Практическое задание удалено:', id)
					} catch (error) {
						console.error(
							'❌ Ошибка удаления практического задания:',
							id,
							error
						)
					}
				}
			}

			// Удаляем домашние задания
			if (deletedElements.homework?.length > 0) {
				for (const id of deletedElements.homework) {
					try {
						console.log('🗑️ Удаление домашнего задания из БД:', id)
						await homeworkService.delete(id)
						console.log('✅ Домашнее задание удалено:', id)
					} catch (error) {
						console.error('❌ Ошибка удаления домашнего задания:', id, error)
					}
				}
			}

			console.log('✅ Все удаления обработаны')
		},

		/**
		 * Сохранение локальных материалов в БД
		 */
		async saveLocalMaterialsToDB(moduleId, moduleElements) {
			console.log(
				'💾 Сохранение локальных материалов в БД для модуля:',
				moduleId
			)
			console.log('📦 Материалы для сохранения:', moduleElements)

			if (!moduleElements || typeof moduleElements !== 'object') {
				console.error('❌ moduleElements не является объектом')
				return
			}

			const {
				lessonsService,
				testsService,
				practicalService,
				homeworkService,
			} = await import('@/services')

				const savedIds = {
					lessons: [],
					tests: [],
					practice: [],
					homework: [],
				}
				const saveErrors = []

			const isDraftFlag = (item, fullData) =>
				item?.isDraft === true ||
				item?.is_draft === true ||
				fullData?.isDraft === true ||
				fullData?.is_draft === true

			const hasMaterialChanges = (item, fullData) =>
				item?.hasLocalChanges === true ||
				fullData?.hasLocalChanges === true ||
				item?._modified === true ||
				fullData?._modified === true

			const materialHandlers = {
				lessons: {
					service: lessonsService,
					mapPayload: (fullData, isDraft) => {
						console.log('🔍 [lessons.mapPayload] fullData:', {
							scheduled_publish_at: fullData.scheduled_publish_at,
							publishType: fullData.publishType,
							publishDate: fullData.publishDate,
							publishTime: fullData.publishTime,
						})

						// Вычисляем scheduled_publish_at
						let scheduledPublishAt = fullData.scheduled_publish_at || null
						if (
							!scheduledPublishAt &&
							fullData.publishType === 'scheduled' &&
							fullData.publishDate &&
							fullData.publishTime
						) {
							scheduledPublishAt = `${fullData.publishDate} ${fullData.publishTime}`
						}
						const isHidden =
							fullData.is_hidden ?? fullData.isHidden ?? false

						const lessonPayload = {
							title: fullData.title || 'Новый урок',
							description: fullData.description || '',
							content: fullData.content || '',
							lesson_type: fullData.type || 'video',
							duration_minutes:
								fullData.duration || fullData.duration_minutes || 30,
							is_published: scheduledPublishAt ? false : !isDraft && !isHidden,
							is_draft: isDraft,
							scheduled_publish_at: scheduledPublishAt,
						}

						console.log('🔍 [lessons.mapPayload] payload:', {
							scheduled_publish_at: lessonPayload.scheduled_publish_at,
							is_published: lessonPayload.is_published,
						})

						if (fullData.type === 'article') {
							lessonPayload.article_content =
								fullData.articleContent || fullData.content || ''
						}

						if (fullData.videoUrl || fullData.video_url) {
							lessonPayload.video_url =
								fullData.videoUrl || fullData.video_url || ''
						}
						if (
							Object.prototype.hasOwnProperty.call(fullData, 'videoCoverUrl') ||
							Object.prototype.hasOwnProperty.call(fullData, 'cover_image_url') ||
							Object.prototype.hasOwnProperty.call(fullData, 'cover_image')
						) {
							lessonPayload.cover_image_url =
								fullData.videoCoverUrl ||
								fullData.cover_image_url ||
								fullData.cover_image ||
								null
						}

						const enableToc = fullData.enable_toc ?? fullData.enableToc
						if (enableToc !== undefined) {
							lessonPayload.enable_toc = enableToc
						}

						const tocMode = fullData.toc_mode ?? fullData.tocMode
						if (tocMode !== undefined && tocMode !== null && tocMode !== '') {
							lessonPayload.toc_mode = tocMode
						}

						const disableMainMaterialsDownload =
							fullData.disable_main_materials_download ??
							fullData.disableMainMaterialsDownload
						if (disableMainMaterialsDownload !== undefined) {
							lessonPayload.disable_main_materials_download =
								disableMainMaterialsDownload
						}

						const disableAdditionalMaterialsDownload =
							fullData.disable_additional_materials_download ??
							fullData.disableAdditionalMaterialsDownload
						if (disableAdditionalMaterialsDownload !== undefined) {
							lessonPayload.disable_additional_materials_download =
								disableAdditionalMaterialsDownload
						}

						return lessonPayload
					},
					afterSave: async (savedItem, fullData) => {
						const lessonId = savedItem?.id
						if (!lessonId) return

						if (fullData.videoFile instanceof File) {
							console.log('📹 Загрузка видео для урока:', lessonId)
							await lessonsService.uploadVideo(lessonId, fullData.videoFile)
						}
						if (fullData.videoCoverFile instanceof File) {
							await lessonsService.uploadCover(lessonId, fullData.videoCoverFile)
						}

						if (Array.isArray(fullData.materials)) {
							const files = fullData.materials.filter(m => m instanceof File)
							if (files.length > 0) {
								console.log(`📎 Загрузка ${files.length} материалов`)
								const uploadResult = await lessonsService.uploadMaterials(
									lessonId,
									files
								)
								if (Array.isArray(uploadResult?.additional_materials)) {
									// Убираем локальные File и добавляем только действительно новые загруженные материалы
									const nonFileMaterials = fullData.materials.filter(
										m => !(m instanceof File)
									)
									const newUploaded = uploadResult.additional_materials.filter(
										uploaded =>
											!nonFileMaterials.some(
												existing => existing.url === uploaded.url
											)
									)
									fullData.materials = [...nonFileMaterials, ...newUploaded]
								} else if (Array.isArray(uploadResult?.materials)) {
									fullData.materials = uploadResult.materials
								} else {
									fullData.materials = fullData.materials.filter(
										m => !(m instanceof File)
									)
								}
							}
						}

						if (Array.isArray(fullData.deletedMaterials)) {
							console.log(
								'🗑️ Удаление материалов урока:',
								fullData.deletedMaterials
							)
							for (const material of fullData.deletedMaterials) {
								// Используем id, url или file_path для идентификации материала
								const materialId = material.id || material.url || material.file_path
								if (materialId) {
									try {
										await lessonsService.deleteMaterial(
											lessonId,
											materialId
										)
										console.log('✅ Материал удален:', materialId)
									} catch (err) {
										console.error('❌ Ошибка удаления материала:', err)
									}
								}
							}
							fullData.deletedMaterials = []
						}

						if (fullData.docFile instanceof File) {
							console.log('📄 Загрузка документа для урока:', lessonId)
							await lessonsService.uploadDocument(lessonId, fullData.docFile)
						}

						if (fullData.deletedDocFile) {
							console.log('🗑️ Удаление документа урока:', lessonId)
							await lessonsService.deleteDocument(lessonId)
						}
					},
				},
				tests: {
					service: testsService,
					mapPayload: (fullData, isDraft) => {
						console.log('🔍 [tests.mapPayload] fullData:', {
							scheduled_publish_at: fullData.scheduled_publish_at,
							isScheduledPublish: fullData.isScheduledPublish,
							publishDate: fullData.publishDate,
							publishTime: fullData.publishTime,
							is_hidden: fullData.is_hidden,
							autoPublish: fullData.autoPublish,
						})

						// Вычисляем scheduled_publish_at из разных источников
						let scheduledPublishAt = fullData.scheduled_publish_at || null
						if (
							!scheduledPublishAt &&
							fullData.isScheduledPublish &&
							fullData.publishDate &&
							fullData.publishTime
						) {
							scheduledPublishAt = `${fullData.publishDate} ${fullData.publishTime}`
						}
						// Также проверяем autoPublish === false
						if (
							!scheduledPublishAt &&
							fullData.autoPublish === false &&
							fullData.publishDate &&
							fullData.publishTime
						) {
							scheduledPublishAt = `${fullData.publishDate} ${fullData.publishTime}`
						}
						// Если есть scheduled_publish_at - тест скрыт
						const isHidden = scheduledPublishAt
							? true
							: fullData.is_hidden ?? false
						// Если по расписанию - не опубликован
						const isPublished = scheduledPublishAt ? false : !isDraft

						console.log('🔍 [tests.mapPayload] вычислено:', {
							scheduledPublishAt,
							isHidden,
							isPublished,
						})

						const questions = Array.isArray(fullData.questions)
							? fullData.questions.map(question => {
									const answers = Array.isArray(question?.answers)
										? question.answers.map(answer => {
												const rawAnswerImage =
													answer?.image_url ??
													answer?.imageUrl ??
													answer?.image ??
													null
												const answerImageUrl =
													typeof rawAnswerImage === 'string' &&
													rawAnswerImage.startsWith('data:')
														? null
														: rawAnswerImage

												return {
													...answer,
													text: answer?.text ?? answer?.answer_text ?? '',
													answer_text:
														answer?.answer_text ?? answer?.text ?? '',
													is_correct:
														answer?.isCorrect ?? answer?.is_correct ?? false,
													image_url: answerImageUrl,
													imageUrl: answerImageUrl,
													image: answerImageUrl,
												}
										  })
										: []

									const rawImage =
										question?.image_url ??
										question?.imageUrl ??
										question?.image ??
										null
									const imageUrl =
										typeof rawImage === 'string' && rawImage.startsWith('data:')
											? null
											: rawImage

									return {
										...question,
										text: question?.text ?? question?.question_text ?? '',
										question_text:
											question?.question_text ?? question?.text ?? '',
										type: question?.type ?? question?.question_type ?? 'text',
										question_type:
											question?.question_type ?? question?.type ?? 'text',
										correct_text:
											question?.correctText ??
											question?.correct_text ??
											question?.correct_answer ??
											'',
										case_sensitive:
											question?.caseSensitive ??
											question?.case_sensitive ??
											false,
										explanation: question?.explanation ?? '',
										tags: question?.tags ?? '',
										custom_points:
											question?.customPoints ?? question?.custom_points ?? null,
										points: question?.customPoints ?? question?.points ?? null,
										image_url: imageUrl,
										imageUrl: imageUrl,
										image: imageUrl,
										answers,
									}
							  })
							: []

						return {
							title: fullData.title || 'Новый тест',
							description: fullData.description || '',
							duration_minutes:
								fullData.duration ?? fullData.duration_minutes ?? 0,
							passing_score:
								fullData.passingScore ?? fullData.passing_score ?? 70,
							max_attempts: fullData.attempts ?? fullData.max_attempts ?? 1,
							points_per_question:
								fullData.pointsPerQuestion ??
								fullData.points_per_question ??
								1,
							random_order:
								fullData.randomOrder ?? fullData.random_order ?? false,
							show_correct_answers:
								fullData.showCorrectAnswers ??
								fullData.show_correct_answers ??
								true,
							allow_review:
								fullData.allowReview ?? fullData.allow_review ?? true,
							penalize_wrong:
								fullData.penalizeWrong ?? fullData.penalize_wrong ?? false,
							penalty_percentage:
								fullData.penaltyPercentage ?? fullData.penalty_percentage ?? 50,
							disable_copying:
								fullData.disableCopying ?? fullData.disable_copying ?? false,
							limit_time_per_question:
								fullData.limitTimePerQuestion ??
								fullData.limit_time_per_question ??
								false,
							time_per_question:
								fullData.timePerQuestion ?? fullData.time_per_question ?? 0,
							select_random_questions:
								fullData.selectRandomQuestions ??
								fullData.select_random_questions ??
								false,
							questions_to_show:
								fullData.questionsToShow ?? fullData.questions_to_show ?? 0,
							question_distribution_mode:
								fullData.questionDistributionMode ??
								fullData.question_distribution_mode ??
								'random',
							question_type_distribution:
								fullData.questionTypeDistribution ??
								fullData.question_type_distribution ??
								{},
							is_published: isPublished,
							is_draft: isDraft,
							is_hidden: isHidden,
							scheduled_publish_at: scheduledPublishAt,
							questions,
						}
					},
					afterSave: async (savedItem, fullData) => {
						const testId = savedItem?.id
						if (!testId) return

						const localQuestions = Array.isArray(fullData.questions)
							? fullData.questions
							: []
						const hasImages = localQuestions.some(
							q =>
								q?.imageFile instanceof File ||
								(q?.answers || []).some(a => a?.imageFile instanceof File)
						)
						if (!hasImages) return

						let savedTest = savedItem
						if (!Array.isArray(savedItem?.questions)) {
							savedTest = await testsService.getWithQuestions(testId)
						}

						const savedQuestions = Array.isArray(savedTest?.questions)
							? savedTest.questions
							: []

						for (let i = 0; i < localQuestions.length; i++) {
							const localQuestion = localQuestions[i]
							const savedQuestion =
								savedQuestions.find(
									q => Number(q.order_number) === i + 1
								) || savedQuestions[i]

							if (!savedQuestion?.id) continue

							const savedQuestionImage =
								savedQuestion?.image_url ??
								savedQuestion?.imageUrl ??
								savedQuestion?.image ??
								null
							const localQuestionImage =
								typeof localQuestion?.image === 'string'
									? localQuestion.image
									: null
							const hasLocalQuestionImage =
								!!localQuestionImage && localQuestionImage.trim() !== ''

							if (localQuestion?.imageFile instanceof File) {
								try {
									const uploadResult =
										await testsService.uploadQuestionImage(
											savedQuestion.id,
											localQuestion.imageFile
										)
									console.log(
										'🖼️ Ответ uploadQuestionImage:',
										uploadResult
									)
									const uploadedUrl =
										uploadResult?.image_url ??
										uploadResult?.imageUrl ??
										uploadResult?.image ??
										null
									if (uploadedUrl) {
										localQuestion.image = uploadedUrl
									}
									localQuestion.imageFile = null
								} catch (error) {
									console.error(
										'⚠️ Ошибка загрузки изображения вопроса:',
										error
									)
								}
							} else if (!hasLocalQuestionImage && savedQuestionImage) {
								try {
									await testsService.deleteQuestionImage(savedQuestion.id)
									console.log(
										'🗑️ Удалено изображение вопроса:',
										savedQuestion.id
									)
								} catch (error) {
									console.error(
										'⚠️ Ошибка удаления изображения вопроса:',
										error
									)
								}
							}

							const savedAnswers = Array.isArray(savedQuestion.answers)
								? savedQuestion.answers.filter(a => a && a.id)
								: []
							const localAnswers = Array.isArray(localQuestion?.answers)
								? localQuestion.answers
								: []

							for (let j = 0; j < localAnswers.length; j++) {
								const localAnswer = localAnswers[j]
								const savedAnswer =
									savedAnswers.find(
										a => Number(a.order_number) === j + 1
									) || savedAnswers[j]
								if (!savedAnswer?.id) continue

								const savedAnswerImage =
									savedAnswer?.image_url ??
									savedAnswer?.imageUrl ??
									savedAnswer?.image ??
									null
								const localAnswerImage =
									typeof localAnswer?.image === 'string'
										? localAnswer.image
										: null
								const hasLocalAnswerImage =
									!!localAnswerImage && localAnswerImage.trim() !== ''

								if (!(localAnswer?.imageFile instanceof File)) {
									if (!hasLocalAnswerImage && savedAnswerImage) {
										try {
											await testsService.deleteAnswerImage(savedAnswer.id)
											console.log(
												'🗑️ Удалено изображение ответа:',
												savedAnswer.id
											)
										} catch (error) {
											console.error(
												'⚠️ Ошибка удаления изображения ответа:',
												error
											)
										}
									}
									continue
								}

								try {
									const uploadResult =
										await testsService.uploadAnswerImage(
											savedAnswer.id,
											localAnswer.imageFile
										)
									console.log(
										'🖼️ Ответ uploadAnswerImage:',
										uploadResult
									)
									const uploadedUrl =
										uploadResult?.image_url ??
										uploadResult?.imageUrl ??
										uploadResult?.image ??
										null
									if (uploadedUrl) {
										localAnswer.image = uploadedUrl
									}
									localAnswer.imageFile = null
								} catch (error) {
									console.error(
										'⚠️ Ошибка загрузки изображения ответа:',
										error
									)
								}
							}
						}
					},
				},
				practice: {
					service: practicalService,
					mapPayload: (fullData, isDraft) => {
						const isHidden =
							fullData.is_hidden ?? fullData.isHidden ?? false
						const practicePayload = {
							title: fullData.title || 'Новое практическое задание',
							content:
								fullData.content ||
								fullData.description ||
								fullData.goal ||
								fullData.task_description ||
								'',
							questions: fullData.questions || [],
							materials: (fullData.materials || []).filter(m => !(m instanceof File)),
							estimated_time_minutes:
								fullData.estimatedTime ||
								fullData.estimated_time_minutes ||
								null,
							is_published: !isDraft && !isHidden,
							is_draft: isDraft,
						}

						if (fullData.miniTest || fullData.mini_test) {
							practicePayload.mini_test =
								fullData.miniTest || fullData.mini_test
						}

						return practicePayload
					},
					afterSave: async (savedItem, fullData) => {
						const practiceId = savedItem?.id
						if (!practiceId) return

						if (Array.isArray(fullData.materials)) {
							const files = fullData.materials.filter(m => m instanceof File)
							if (files.length > 0) {
								console.log(`📎 Загрузка ${files.length} материалов`)
								const uploadResult = await practicalService.uploadMaterials(
									practiceId,
									files
								)
								if (Array.isArray(uploadResult?.materials)) {
									fullData.materials = uploadResult.materials
								} else {
									fullData.materials = fullData.materials.filter(
										m => !(m instanceof File)
									)
								}
							}
						}

						if (Array.isArray(fullData.deletedMaterials)) {
							const existingMaterialIds = new Set()
							try {
								const latestPractice = await practicalService.getById(practiceId)
								const latestMaterials = Array.isArray(latestPractice?.materials)
									? latestPractice.materials
									: []
								for (const existingMaterial of latestMaterials) {
									if (typeof existingMaterial?.id === 'number') {
										existingMaterialIds.add(existingMaterial.id)
									}
								}
							} catch (err) {
								console.warn(
									'Cannot preload practice materials before delete:',
									err?.message || err
								)
							}
							for (const material of fullData.deletedMaterials) {
								const materialId =
									material.id
								if (
									materialId &&
									typeof materialId === 'number' &&
									(existingMaterialIds.size === 0 ||
										existingMaterialIds.has(materialId))
								) {
									try {
										await practicalService.deleteMaterial(
											practiceId,
											materialId
										)
									} catch (err) {
										if (err?.status !== 404) {
											throw err
										}
										console.warn(
											'Practice material already removed:',
											materialId
										)
									}
								} else if (materialId && typeof materialId === 'number') {
									console.warn(
										'Skip delete for missing practice material:',
										materialId
									)
								}
							}
							fullData.deletedMaterials = []
						}
					},
				},
				homework: {
					service: homeworkService,
					mapPayload: (fullData, isDraft) => {
						const isHidden =
							fullData.is_hidden ?? fullData.isHidden ?? false
						const existingMaterials = (fullData.materials || []).filter(
							m => !(m instanceof File)
						)
						return {
							title: fullData.title || 'Новое домашнее задание',
							description: fullData.description || '',
							requirements: Array.isArray(fullData.requirements)
								? JSON.stringify(fullData.requirements)
								: fullData.requirements || '',
							due_date: fullData.dueDate || null,
							due_time: fullData.dueTime || null,
							max_score: fullData.maxScore ?? null,
							materials: existingMaterials,
							is_published: !isDraft && !isHidden,
							is_draft: isDraft,
							allow_late_submission: fullData.allowLateSubmission ?? false,
						}
					},
					afterSave: async (savedItem, fullData) => {
						const homeworkId = savedItem?.id
						if (!homeworkId) return

						if (Array.isArray(fullData.materials)) {
							const files = fullData.materials.filter(m => m instanceof File)
							if (files.length > 0) {
								console.log(
									`📎 Загрузка ${files.length} материалов домашнего задания`
								)
								const uploadResult = await homeworkService.uploadMaterials(
									homeworkId,
									files
								)
								if (Array.isArray(uploadResult?.materials)) {
									fullData.materials = uploadResult.materials
								} else {
									fullData.materials = fullData.materials.filter(
										m => !(m instanceof File)
									)
								}
							}
						}

						if (Array.isArray(fullData.deletedMaterials)) {
							for (const material of fullData.deletedMaterials) {
								const filePath = material.file_path || material.url
								if (filePath) {
									try {
										await homeworkService.deleteMaterial(homeworkId, filePath)
									} catch (err) {
										console.warn('⚠️ Ошибка удаления материала:', err.message)
									}
								}
							}
							fullData.deletedMaterials = []
						}
					},
				},
			}

			const processType = async type => {
				const handler = materialHandlers[type]
				const items = Array.isArray(moduleElements[type])
					? moduleElements[type]
					: []

				for (const item of items) {
					try {
						const fullData = item.fullData || item
						const isDraft = isDraftFlag(item, fullData)
						const payload = handler.mapPayload(fullData, isDraft)
						const sourceId = fullData.id ?? item.id
						const shouldCreate = !this.isExistingId(sourceId)
						const shouldUpdate = hasMaterialChanges(item, fullData)
						if (!shouldCreate && !shouldUpdate) {
							continue
						}
						const savedItem = shouldCreate
							? await handler.service.create(moduleId, payload)
							: await handler.service.update(fullData.id, payload)

						if (handler.afterSave) {
							await handler.afterSave(savedItem, fullData)
						}

						if (savedItem?.id) {
							if (shouldCreate) {
								const previousId = sourceId
								fullData.id = savedItem.id
								item.id = savedItem.id
								if (item.fullData && typeof item.fullData === 'object') {
									item.fullData.id = savedItem.id
								}
								if (previousId !== undefined && previousId !== null) {
									fullData.tempId = previousId
									item.tempId = previousId
									if (item.fullData && typeof item.fullData === 'object') {
										item.fullData.tempId = previousId
									}
								}
							}
							savedIds[type].push(savedItem.id)
							console.log(`✅ ${type} сохранен: ${savedItem.id}`)
						}
						item.hasLocalChanges = false
						item._modified = false
						if (item.fullData && typeof item.fullData === 'object') {
							item.fullData.hasLocalChanges = false
							item.fullData._modified = false
						}
						} catch (error) {
							console.error(`❌ Ошибка сохранения ${type}:`, error)
							saveErrors.push({ type, error })
						}
				}
			}

				await Promise.all([
					processType('lessons'),
					processType('tests'),
					processType('practice'),
					processType('homework'),
				])
				if (saveErrors.length > 0) {
					const details = saveErrors
						.map(item => `${item.type}: ${item.error?.message || 'unknown error'}`)
						.join('; ')
					const partialSaveError = new Error(
						`Часть материалов не сохранена (${saveErrors.length}). ${details}`
					)
					partialSaveError.code = 'PARTIAL_SAVE_FAILURE'
					partialSaveError.details = saveErrors
					throw partialSaveError
				}

				console.log('✅ Все материалы сохранены:', savedIds)
				return savedIds
			},

		handleCancelModuleCreation() {
			this.showModuleCreation = false
			this.autoOpenModuleForm = false
			this.editingModuleId = null
			console.log('Отмена создания модуля')
		},

		// Закрытие формы редактирования при возврате из preview в Bitrix
		handleCloseEditingForm() {
			console.log('[CreateCourse] handleCloseEditingForm called')
			this.showModuleCreation = false
			this.autoOpenModuleForm = false
			this.editingModuleId = null
			this.activeTab = 'modules'
			console.log('[Bitrix] Возврат из preview: форма закрыта, вкладка переключена на модули')
		},

		// === ЗАГРУЗКА КОНФЕРЕНЦИЙ ===
		async loadConferences() {
			if (!this.courseId) return

			this.conferencesLoading = true
			try {
				const response = await conferencesService.getByCourseId(
					this.courseId,
					true, // includePast
					true // includeUnpublished
				)
				this.conferences = this.normalizeConferencesResponse(response)
			} catch (error) {
				console.error('Не удалось загрузить конференции:', error)
				this.conferences = []
			} finally {
				this.conferencesLoading = false
			}
		},

		normalizeConferencesResponse(data) {
			if (Array.isArray(data)) return data
			if (Array.isArray(data?.data)) return data.data
			if (Array.isArray(data?.conferences)) return data.conferences
			return []
		},

		// === ФОРМА КОНФЕРЕНЦИИ ===
		openConferenceForm(conference = null) {
			this.selectedConference = conference
			this.showConferenceForm = true
			this.$nextTick(() => {
				const firstInput = this.$refs.conferenceForm?.$el?.querySelector(
					'input, select, textarea, button'
				)
				firstInput?.focus()
			})
		},

		handleEditConference(conference) {
			this.openConferenceForm(conference)
		},

		async handleDeleteConference(conference) {
			if (!confirm(`Удалить конференцию "${conference.title}"?`)) {
				return
			}

			try {
				await conferencesService.delete(conference.id)
				await this.loadConferences()
				this.showNotification('Конференция удалена', 'success')
			} catch (error) {
				console.error('Failed to delete conference:', error)
				this.showNotification('Не удалось удалить конференцию', 'error')
			}
		},

		async handleConferenceSubmit(conferenceData) {
			if (!this.courseId) {
				this.showNotification('Сначала создайте курс', 'error', 5000)
				return
			}

			this.savingConference = true

			try {
				if (this.selectedConference && this.selectedConference.id > 0) {
					await conferencesService.update(
						this.selectedConference.id,
						conferenceData
					)
					this.showNotification('Конференция обновлена', 'success')
				} else {
					await conferencesService.create(this.courseId, conferenceData)
					this.showNotification('Конференция создана', 'success')
				}

				await this.loadConferences()
				this.closeConferenceForm()
			} catch (error) {
				console.error('Failed to save conference:', error)
				this.showNotification('Не удалось сохранить конференцию', 'error')
			} finally {
				this.savingConference = false
			}
		},

		closeConferenceForm() {
			this.showConferenceForm = false
			this.selectedConference = null
		},

		// Редактирование модуля
		handleEditModule(payload) {
			const moduleId = typeof payload === 'object' ? payload.id : payload
			console.log('Редактирование модуля:', moduleId)

			this.editingModuleId = moduleId
			this.showModuleCreation = true
			this.autoOpenModuleForm = true
		},

		// Удаление модуля
		async handleDeleteModule(payload) {
			const moduleId = typeof payload === 'object' ? payload.id : payload

			if (!confirm('Вы уверены, что хотите удалить этот модуль?')) {
				return
			}

			try {
				console.log('Удаление модуля:', moduleId)
				await modulesService.delete(moduleId)
				await this.loadModules(this.courseId)

				this.showNotification('Модуль успешно удалён!', 'success')
			} catch (error) {
				console.error('Ошибка при удалении модуля:', error)
				this.showNotification(
					'Ошибка при удалении модуля: ' + error.message,
					'error',
					6000
				)
			}
		},

		// Переключение видимости модуля
		async handleToggleModuleVisibility(data) {
			try {
				const moduleId = typeof data === 'object' ? data.id : data
				const currentModule = this.modules.find(m => m.id === moduleId)
				const currentHidden =
					currentModule?.isHidden ?? currentModule?.is_hidden ?? false
				let newHiddenState

				if (typeof data === 'object' && typeof data.isHidden === 'boolean') {
					// Если пришло текущее значение, инвертируем; иначе принимаем как целевое
					newHiddenState =
						data.isHidden === currentHidden ? !currentHidden : data.isHidden
				} else {
					newHiddenState = !currentHidden
				}
				console.log(
					'Переключение видимости модуля:',
					moduleId,
					'→',
					newHiddenState
				)

				// Оптимистично обновляем локальный стейт, чтобы сразу показать скрытый/видимый статус
				this.modules = this.modules.map(m =>
					m.id === moduleId
						? {
								...m,
								isHidden: newHiddenState,
								is_hidden: newHiddenState,
						  }
						: m
				)

				await modulesService.update(moduleId, {
					is_hidden: newHiddenState,
				})

				await this.loadModules(this.courseId)
				this.showNotification('Видимость модуля изменена', 'success', 2500)
			} catch (error) {
				console.error('Ошибка при изменении видимости модуля:', error)
				this.showNotification(
					'Ошибка при изменении видимости модуля: ' + error.message,
					'error',
					6000
				)
			}
		},

		// Сохранение состояния в localStorage
		saveState() {
			if (authState.isLoggingOut) {
				return
			}

			try {
				const state = {
					activeTab: this.activeTab,
					showModuleCreation: this.showModuleCreation,
				}
				localStorage.setItem('createCourse_state', JSON.stringify(state))
			} catch (error) {
				console.warn('Не удалось сохранить состояние в localStorage:', error)
			}
		},

		clearCreateCourseStorage() {
			try {
				localStorage.removeItem('createCourse_state')
				localStorage.removeItem('createCourse_courseId')
				sessionStorage.removeItem('createCourse_isOnPage')
			} catch (error) {
				console.warn('Не удалось очистить состояние CreateCourse:', error)
			}
		},

		// Восстановление состояния из localStorage
		restoreState() {
			try {
				const savedState = localStorage.getItem('createCourse_state')
				if (savedState) {
					const state = JSON.parse(savedState)
					if (state.activeTab) {
						this.activeTab = state.activeTab
					}
					if (state.showModuleCreation !== undefined) {
						this.showModuleCreation = state.showModuleCreation
					}
				}
			} catch (error) {
				console.warn(
					'Не удалось восстановить состояние из localStorage:',
					error
				)
			}
		},

		// 👇 СОХРАНЕНИЕ КУРСА В LOCALSTORAGE
		saveCourseToLocalStorage() {
			if (!this.courseId) return

			try {
				const courseData = {
					id: this.courseId,
					title: this.courseTitle,
					subtitle: this.courseSubtitle,
					description: this.courseDescription,
					category: this.selectedCategory,
					tags: this.courseTags,
					cover_image_url: this.coverPreview,
					demo_media_path: this.demoMediaPath,
					demo_media_name: this.demoMediaName,
					demo_media_type: this.demoMediaType,
					presentation_audience: this.presentationAudience,
					presentation_format: this.presentationFormat,
					presentation_benefits: this.presentationBenefits,
					presentation_outcome: this.presentationOutcome,
					timestamp: Date.now(),
				}

				const coursesKey = 'teacher_courses'
				const existingCourses = JSON.parse(
					localStorage.getItem(coursesKey) || '[]'
				)

				const courseIndex = existingCourses.findIndex(
					c => c.id === this.courseId
				)
				if (courseIndex >= 0) {
					existingCourses[courseIndex] = courseData
				} else {
					existingCourses.push(courseData)
				}

				localStorage.setItem(coursesKey, JSON.stringify(existingCourses))
				console.log(`✅ Курс ${this.courseId} сохранен в localStorage`)
			} catch (error) {
				console.error('❌ Ошибка сохранения курса в localStorage:', error)
			}
		},

		// Reset form
		resetForm() {
			this.courseId = null
			this.courseTitle = ''
			this.courseSubtitle = ''
			this.courseDescription = ''
			this.courseShortDescription = ''
			this.selectedCategory = ''
			this.courseTags = []
			this.newTag = ''
			this.coverFile = null
			this.coverPreview = null
			this.demoMediaFile = null
			this.demoMediaPath = null
			this.demoMediaName = ''
			this.demoMediaType = ''
			this.presentationAudience = ''
			this.presentationFormat = ''
			this.presentationBenefits = ''
			this.presentationOutcome = ''
			this.difficultyLevel = ''
			this.durationHours = null
			this.price = 0
			this.maxStudents = null
			this.unlimitedStudents = true
			this.isFree = false
			this.isPublished = true
			this.isHidden = false
			this.activeTab = 'description'
			this.showModuleCreation = false
			this.autoOpenModuleForm = false
			this.loading = false
			this.saving = false
			this.error = null
			this.conferences = []
			this.certificates = []
			this.faqs = []

			this.clearCreateCourseStorage()
		},
	},
}
</script>

<style scoped>
.create-course-page {
	background-color: #f9f9f980;
	min-height: 100vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
}

/* Notification */
.notification {
	position: fixed;
	top: 20px;
	right: 20px;
	padding: 12px 20px;
	border-radius: 8px;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
	z-index: 10100;
	color: #ffffff;
	white-space: pre-line;
}

.notification--success {
	background-color: #28a745;
}

.notification--error {
	background-color: #dc3545;
}

/* fade transition */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

/* ============================================
   LOADING INDICATOR
   ============================================ */
.ccp-loading {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 80px 20px;
	min-height: 400px;
}

.ccp-loading__spinner {
	width: 50px;
	height: 50px;
	border: 4px solid #f3f3f3;
	border-top: 4px solid #0095ec;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.ccp-loading__text {
	margin-top: 20px;
	color: #636363;
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	font-weight: 500;
}

.content-wrapper {
	max-width: 1200px;
	margin: 0 auto;
	padding: 40px;
	background-color: #ffffff;
	border-radius: 20px;
	box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
}

.page-title {
	color: #252641;
	font-family: 'Poppins', Helvetica;
	font-size: 36px;
	font-weight: 700;
	margin-bottom: 40px;
	text-align: center;
}

.course-creation-placeholder {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 80px 20px;
	text-align: center;
}

.placeholder-icon {
	font-size: 80px;
	margin-bottom: 20px;
}

.placeholder-text {
	color: #636363;
	font-family: 'Poppins', Helvetica;
	font-size: 18px;
	margin-bottom: 30px;
}

.back-button {
	background-color: #0095ec;
	color: #ffffff;
	border: none;
	border-radius: 10px;
	padding: 12px 30px;
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
}

.back-button:hover {
	background-color: #0077be;
	transform: translateY(-2px);
	box-shadow: 0px 4px 12px rgba(0, 149, 236, 0.3);
}

.back-button:active {
	transform: translateY(0);
}

/* ============================================
   MAIN CONTAINER
   ============================================ */
.ccp-container {
	max-width: 1400px;
	margin: 0 auto;
	padding: 20px 40px 80px;
	width: 100%;
	box-sizing: border-box;
}

/* ============================================
   BREADCRUMB NAVIGATION
   ============================================ */
.ccp-breadcrumb {
	color: rgba(0, 0, 0, 0.7);
	display: flex;
	font-family: 'Poppins', Helvetica;
	font-size: 18px;
	font-weight: 400;
	gap: 8px;
	letter-spacing: 0.4px;
	line-height: 36px;
	white-space: nowrap;
	margin-bottom: 20px;
}

.ccp-breadcrumb__item {
	letter-spacing: 0.08px;
}

.ccp-breadcrumb__item--link {
	cursor: pointer;
	font-weight: 500;
	transition: color 0.3s ease;
	user-select: none;
}

.ccp-breadcrumb__item--link:hover {
	color: #0095ec;
	text-decoration: underline;
}

.ccp-breadcrumb__item--link:active {
	color: #0077be;
}

.ccp-breadcrumb__separator {
	font-weight: 100;
	letter-spacing: 0.08px;
}

/* ============================================
   BREADCRUMBS - CoursePreview Style
   ============================================ */
.breadcrumbs {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 10px 20px;
	background: rgba(255, 255, 255, 0.85);
	backdrop-filter: blur(20px);
	border: 1px solid rgba(255, 255, 255, 0.18);
	border-radius: 9999px;
	margin-bottom: 32px;
	box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
	font-family: 'Poppins', Helvetica;
}

.breadcrumbs__link {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	color: #475569;
	text-decoration: none;
	font-size: 13px;
	font-weight: 500;
	transition: all 0.2s ease;
	padding: 4px 8px;
	border-radius: 8px;
	cursor: pointer;
}

.breadcrumbs__link:hover {
	color: #0095ec;
	background: rgba(0, 149, 236, 0.1);
}

.breadcrumbs__icon {
	width: 14px;
	height: 14px;
}

.breadcrumbs__separator {
	width: 16px;
	height: 16px;
	color: #94a3b8;
	opacity: 0.5;
}

.breadcrumbs__current {
	color: #ffffff;
	font-weight: 600;
	font-size: 13px;
	white-space: normal;
	padding: 4px 12px;
	background: #0095ec;
	border-radius: 9999px;
}

/* ============================================
   COVER SECTION
   ============================================ */
.ccp-cover {
	height: 500px;
	position: relative;
	width: 100%;
	margin-bottom: 30px;
	border-radius: 12px;
	overflow: hidden;
}

.ccp-cover__bg {
	height: 100%;
	left: 0;
	object-fit: cover;
	position: absolute;
	top: 0;
	width: 100%;
}

.ccp-cover__bg--placeholder {
	background: #bcbcbc;
}

/* Upload Cover Button */
.ccp-cover__upload-btn {
	background: transparent;
	border: none;
	cursor: pointer;
	height: 50px;
	left: 20px;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative; /* если нужно точное управление слоями */
	text-align: center;
	top: 20px;
	width: 232px;
	z-index: 2;
}

.ccp-cover__upload-btn:hover .ccp-cover__upload-bg {
	background-color: rgba(51, 51, 51, 0.5);
}

.ccp-cover__upload-bg {
	backdrop-filter: blur(5px) brightness(100%);
	background-color: rgba(51, 51, 51, 0.3);
	border-radius: 10px;
	height: 50px;
	left: 0;
	position: absolute;
	top: 0;
	transition: background-color 0.3s ease;
	width: 230px;
}

.ccp-cover__upload-text {
	color: #ffffff;
	font-family: 'Poppins', Helvetica;
	font-size: 18px;
	font-weight: 700;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
}

.ccp-cover__title,
.ccp-cover__subtitle {
  display: inline-block;          /* ширина по содержимому */
  width: auto;
  max-width: min(90%, 60ch);      /* не растягиваться слишком широко */
  
  padding: 10px 16px;
  border-radius: 12px;
  border: none;

  /* темнее фон + сильнее блюр */
  background: rgba(15, 23, 42, 0.62);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  /* тени */
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.30);

	white-space: nowrap;
}

/* Title and Subtitle */
.ccp-cover__title-group,
.ccp-cover__subtitle-group {
	position: absolute;
	z-index: 2;
}

.ccp-cover__title-group {
	left: 40px;
	top: 100px;
	right: 40px;
}

.ccp-cover__subtitle-group {
	left: 40px;
	top: 200px;
	right: 40px;
}

.ccp-cover__edit-icon {
	aspect-ratio: 1;
	cursor: pointer;
	height: 28px;
	left: 0;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	width: 28px;
}

.ccp-cover__edit-icon--title {
	top: 45px;
}

.ccp-cover__edit-icon--subtitle {
	top: 38px;
}

.ccp-cover__title {
	background: transparent;
	border: 2px solid transparent;
	border-radius: 8px;
	color: #e0e0e0;
  text-shadow:
    0 2px 4px rgba(0,0,0,0.55),
    0 10px 24px rgba(0,0,0,0.35);
	font-family: 'Poppins', Helvetica;
	font-size: 30px;
	font-weight: 700;
	left: 42px;
	letter-spacing: 1px;
	line-height: normal;
	padding: 10px 15px;
	position: absolute;
	top: 0;
	transition: border-color 0.3s ease;
	width: calc(100% - 80px);
	max-width: 100%;
}

.ccp-cover__title:focus {
	border-color: #0095ec;
	outline: none;
}

.ccp-cover__subtitle {
	background: transparent;
	border: 2px solid transparent;
	border-radius: 8px;
	color: #e0e0e0;
	font-family: 'Poppins', Helvetica;
	font-size: 25px;
	font-weight: 400;
	left: 42px;
	letter-spacing: 0.8px;
	line-height: normal;
	padding: 10px 15px;
	position: absolute;
	top: 0;
	transition: border-color 0.3s ease;
	width: calc(100% - 80px);
	max-width: 100%;
}

.ccp-cover__subtitle:focus {
	border-color: #0095ec;
	outline: none;
}

/* ============================================
   TABS NAVIGATION
   ============================================ */
.ccp-tabs {
	display: flex;
	gap: 18px;
	height: 60px;
	position: relative;
	width: 100%;
	margin-bottom: 40px;
	flex-wrap: wrap;
}

.ccp-tabs__item {
	align-items: center;
	background-color: #f5f5f5;
	border: none;
	border-radius: 12px;
	color: rgba(0, 0, 0, 0.6);
	cursor: pointer;
	display: flex;
	font-family: 'Poppins', Helvetica;
	font-size: 18px;
	font-weight: 700;
	height: 60px;
	justify-content: center;
	letter-spacing: 0;
	line-height: normal;
	padding: 0 30px;
	transition: all 0.3s ease;
	flex: 1;
	min-width: 150px;
}

.ccp-tabs__item:hover {
	background-color: #e8e8e8;
	color: rgba(0, 0, 0, 0.8);
}

.ccp-tabs__item--active {
	background-color: #0095ecb2;
	color: #ffffff;
}

.ccp-tabs__item--active:hover {
	background-color: #0085d6;
	color: #ffffff;
}

/* ============================================
   FORM SECTION
   ============================================ */
.ccp-form {
	position: relative;
	width: 100%;
	padding-bottom: 100px; /* Место для фиксированных кнопок */
}

/* Form Header */
.ccp-form__header {
	margin-bottom: 32px;
}

.ccp-form__title {
	color: #000000;
	font-family: 'Poppins', Helvetica;
	font-size: 32px;
	font-weight: 600;
	letter-spacing: 0;
	line-height: normal;
	margin: 0 0 8px 0;
}

.ccp-form__subtitle {
	color: rgba(0, 0, 0, 0.6);
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	font-weight: 400;
	letter-spacing: 0;
	line-height: normal;
	margin: 0;
}

/* Компактная сетка полей */
.ccp-form__grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 20px 24px;
	margin-bottom: 24px;
}

/* Секции */
.ccp-section {
	margin-top: 16px;
	margin-bottom: 8px;
}

.ccp-section__title {
	font-family: 'Poppins', Helvetica;
	font-size: 18px;
	font-weight: 600;
	color: #000000;
	margin: 0;
	padding-bottom: 8px;
}

/* ============================================
   FORM FIELDS
   ============================================ */
.ccp-field {
	position: relative;
}

.ccp-field--full {
	grid-column: 1 / -1;
}

.ccp-field__label {
	color: rgba(0, 0, 0, 0.8);
	display: block;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 600;
	letter-spacing: 0;
	line-height: normal;
	margin-bottom: 8px;
}

.ccp-field__hint {
	display: block;
	margin-top: 4px;
	font-size: 12px;
	color: rgba(0, 0, 0, 0.5);
	font-family: 'Poppins', Helvetica;
	font-style: italic;
}

.ccp-field__description {
	margin: 0 0 8px 0;
	font-size: 13px;
	color: rgba(0, 0, 0, 0.6);
	font-family: 'Poppins', Helvetica;
	line-height: 1.4;
}

.ccp-field__message {
	margin-top: 6px;
	font-size: 13px;
	font-family: 'Poppins', Helvetica;
}

.ccp-field__message--error {
	color: #dc3545;
}

/* Input */
.ccp-field__input {
	width: 100%;
	box-sizing: border-box;
	padding: 10px 14px;
	background-color: #ffffff;
	border: 0.5px solid #b4b4b4;
	border-radius: 8px;
	transition: border-color 0.3s ease;
	color: #000000;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	letter-spacing: 0;
	line-height: 1.4;
}

.ccp-field__input:focus {
	outline: none;
	border-color: #0095ec;
	box-shadow: 0 0 0 2px rgba(0, 149, 236, 0.1);
}

.ccp-field__input::placeholder {
	color: rgba(0, 0, 0, 0.3);
}

.ccp-field__input:disabled {
	background-color: #f5f5f5;
	color: rgba(0, 0, 0, 0.4);
	cursor: not-allowed;
}

.ccp-field__input--inline {
	width: 200px;
	margin-left: 16px;
}

/* Toggle group */
.ccp-field__toggle-group {
	display: flex;
	align-items: center;
	gap: 16px;
}

/* Checkbox */
.ccp-field--checkbox {
	display: flex;
	align-items: center;
	margin-top: 8px;
}

.ccp-field--checkboxes {
	margin-top: 0;
}

.ccp-checkboxes-group {
	display: flex;
	gap: 32px;
	flex-wrap: wrap;
	padding: 12px 0;
}

.ccp-field__checkbox-label {
	display: flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	color: rgba(0, 0, 0, 0.8);
	user-select: none;
}

.ccp-field__checkbox {
	width: 20px;
	height: 20px;
	cursor: pointer;
	accent-color: #0095ec;
	flex-shrink: 0;
}

/* Настройки публикации */
.ccp-publish-settings {
	display: flex;
	flex-direction: column;
	gap: 16px;
	background: #f8f9fa;
	padding: 20px;
	border-radius: 12px;
	border: 1px solid #e0e0e0;
}

.ccp-publish-option {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	cursor: pointer;
	padding: 12px;
	border-radius: 8px;
	transition: background-color 0.2s ease;
}

.ccp-publish-option:hover {
	background-color: rgba(0, 149, 236, 0.05);
}

.ccp-publish-option__content {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.ccp-publish-option__title {
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.9);
}

.ccp-publish-option__hint {
	font-family: 'Poppins', Helvetica;
	font-size: 13px;
	color: rgba(0, 0, 0, 0.6);
	line-height: 1.4;
}

/* Textarea */
.ccp-field__textarea {
	width: 100%;
	box-sizing: border-box;
	padding: 12px 14px;
	resize: vertical;
	background-color: #ffffff;
	border: 0.5px solid #b4b4b4;
	border-radius: 8px;
	transition: border-color 0.3s ease;
	color: #000000;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	letter-spacing: 0;
	line-height: 1.5;
}

.ccp-field__textarea--auto {
	min-height: 80px;
	max-height: 300px;
}

.ccp-field__textarea::placeholder {
	color: rgba(0, 0, 0, 0.3);
}

.ccp-field__textarea:focus {
	border-color: #0095ec;
	outline: none;
	box-shadow: 0 0 0 2px rgba(0, 149, 236, 0.1);
}

/* Wrapper для textarea с счётчиком */
.ccp-field__textarea-wrapper {
	position: relative;
}

.ccp-field__counter {
	position: absolute;
	bottom: 8px;
	right: 12px;
	font-size: 12px;
	color: rgba(0, 0, 0, 0.4);
	font-family: 'Poppins', Helvetica;
	background: rgba(255, 255, 255, 0.9);
	padding: 2px 6px;
	border-radius: 4px;
	pointer-events: none;
}

.ccp-field__counter--warning {
	color: #ff9800;
	font-weight: 600;
}

/* Select */
.ccp-field__select-wrapper {
	position: relative;
	width: 100%;
}

.ccp-field__select {
	appearance: none;
	background-color: #ffffff;
	border: 0.5px solid #b4b4b4;
	border-radius: 8px;
	color: rgba(0, 0, 0, 0.7);
	cursor: pointer;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 500;
	height: 42px;
	letter-spacing: 0;
	line-height: normal;
	padding: 0 36px 0 14px;
	transition: border-color 0.3s ease;
	width: 100%;
	box-sizing: border-box;
}

.ccp-field__select:focus {
	border-color: #0095ec;
	outline: none;
	box-shadow: 0 0 0 2px rgba(0, 149, 236, 0.1);
}

.ccp-field__select-icon {
	color: #888888;
	font-family: 'Font Awesome 5 Free-Solid', Helvetica;
	font-size: 20px;
	font-weight: 400;
	letter-spacing: 0.4px;
	line-height: normal;
	pointer-events: none;
	position: absolute;
	right: 26px;
	top: 50%;
	transform: translateY(-50%);
	width: 10px;
}

.ccp-field__select-icon::before {
	content: '▼';
}

/* ============================================
   TAGS FIELD
   ============================================ */
.ccp-tags {
	display: flex;
	gap: 8px;
	align-items: stretch;
}

.ccp-tags__input {
	flex: 1;
	background-color: #ffffff;
	border: 0.5px solid #b4b4b4;
	border-radius: 8px;
	color: #000000;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 500;
	height: 42px;
	letter-spacing: 0;
	line-height: normal;
	padding: 0 14px;
	transition: border-color 0.3s ease;
	box-sizing: border-box;
}

.ccp-tags__input::placeholder {
	color: rgba(0, 0, 0, 0.3);
}

.ccp-tags__input:focus {
	border-color: #0095ec;
	outline: none;
	box-shadow: 0 0 0 2px rgba(0, 149, 236, 0.1);
}

.ccp-tags__add-btn {
	background-color: #0095ec;
	border: none;
	border-radius: 8px;
	color: #ffffff;
	cursor: pointer;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 600;
	height: 42px;
	letter-spacing: 0;
	line-height: normal;
	padding: 0 20px;
	transition: all 0.2s ease;
	white-space: nowrap;
}

.ccp-tags__add-btn:hover {
	background-color: #0085d6;
	transform: translateY(-1px);
}

.ccp-tags__add-btn:active {
	transform: translateY(0);
}

.ccp-tags__add-btn--secondary {
	background-color: transparent;
	border: 1.5px solid #0095ec;
	color: #0095ec;
}

.ccp-tags__add-btn--secondary:hover {
	background-color: rgba(0, 149, 236, 0.08);
	border-color: #0085d6;
	color: #0085d6;
	transform: none;
}

/* Tags List */
.ccp-tags__list {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-top: 15px;
}

.ccp-tags__item {
	align-items: center;
	background-color: #e8f4fd;
	border-radius: 20px;
	color: #0095ec;
	display: inline-flex;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	font-weight: 500;
	gap: 8px;
	letter-spacing: 0;
	padding: 6px 12px;
}

.ccp-tags__item--tag {
	background-color: #e8f4fd;
	color: #0095ec;
	border: 1px solid #b3d9f2;
}

.ccp-tags__item--category {
	background-color: #fff3e0;
	color: #f57c00;
	border: 1px solid #ffcc80;
}

.ccp-tags__remove {
	background: transparent;
	border: none;
	color: #0095ec;
	cursor: pointer;
	font-size: 24px;
	font-weight: 700;
	line-height: 1;
	padding: 0;
	transition: color 0.3s ease;
}

.ccp-tags__remove:hover {
	color: #ff4444;
}

.ccp-demo-upload {
	display: flex;
	align-items: center;
	gap: 12px;
	flex-wrap: wrap;
}

.ccp-demo-upload__btn {
	background: #101828;
	color: #ffffff;
	border: none;
	border-radius: 10px;
	padding: 10px 16px;
	font-size: 14px;
	cursor: pointer;
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ccp-demo-upload__btn:hover {
	transform: translateY(-1px);
	box-shadow: 0 6px 16px rgba(16, 24, 40, 0.2);
}

.ccp-demo-upload__btn:disabled {
	opacity: 0.6;
	cursor: not-allowed;
	transform: none;
	box-shadow: none;
}

.ccp-demo-upload__info {
	font-size: 14px;
	color: #344054;
	display: inline-flex;
	gap: 6px;
	align-items: center;
	flex-wrap: wrap;
}

.ccp-demo-upload__link {
	color: #2563eb;
	text-decoration: none;
}

.ccp-demo-upload__link:hover {
	text-decoration: underline;
}

.ccp-demo-upload__meta {
	color: #667085;
}

/* ============================================
   ACTION BUTTONS - ФИКСИРОВАННЫЕ
   ============================================ */
.ccp-actions {
	display: flex;
	gap: 16px;
	justify-content: flex-end;
	padding: 16px 24px;
}

.ccp-actions--sticky {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background: linear-gradient(to top, rgba(255,255,255,0.98) 0%, rgba(255,255,255,0.95) 100%);
	backdrop-filter: blur(8px);
	box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
	z-index: 100;
	margin: 0;
}

.ccp-actions__btn {
	border-radius: 8px;
	cursor: pointer;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 600;
	height: 44px;
	letter-spacing: 0;
	line-height: normal;
	transition: all 0.2s ease;
	padding: 0 28px;
	min-width: 140px;
}

.ccp-actions__btn:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.ccp-actions__btn--cancel {
	background-color: transparent;
	border: 1.5px solid #0095ec;
	color: #0095ec;
}

.ccp-actions__btn--cancel:hover:not(:disabled) {
	background-color: rgba(0, 149, 236, 0.08);
	border-color: #0085d6;
	color: #0085d6;
}

.ccp-actions__btn--save {
	background-color: #0095ec;
	border: none;
	color: #ffffff;
}

.ccp-actions__btn--save:hover:not(:disabled) {
	background-color: #0085d6;
	transform: translateY(-1px);
	box-shadow: 0 4px 12px rgba(0, 149, 236, 0.3);
}

.ccp-actions__btn--save:active:not(:disabled) {
	transform: translateY(0);
}

/* ============================================
   MODULES LIST / PLACEHOLDER / etc.
   (оставила твои стили без изменений)
   ============================================ */

.ccp-modules-list {
	padding: 30px 0;
}

.ccp-modules-list__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 30px;
	padding: 0 20px;
}

.ccp-modules-list__title {
	color: #000000;
	font-family: 'Poppins', Helvetica;
	font-size: 28px;
	font-weight: 600;
	margin: 0;
}

.ccp-modules-list__add-btn {
	background-color: #0095ec;
	border: none;
	border-radius: 10px;
	color: #ffffff;
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	font-weight: 500;
	padding: 12px 24px;
	cursor: pointer;
	transition: all 0.2s ease;
}

.ccp-modules-list__add-btn:hover {
	background-color: #0085d6;
	transform: translateY(-2px);
	box-shadow: 0px 4px 12px rgba(0, 149, 236, 0.3);
}

.ccp-modules-list__add-btn:active {
	transform: translateY(0);
}

.ccp-modules-list__items {
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 0 20px;
}

.ccp-module-item {
	display: flex;
	align-items: flex-start;
	gap: 20px;
	background-color: #ffffff;
	border: 2px solid rgba(0, 0, 0, 0.1);
	border-radius: 15px;
	padding: 25px;
	transition: all 0.2s ease;
}

.ccp-module-item:hover {
	border-color: rgba(0, 149, 236, 0.3);
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

.ccp-module-item__number {
	flex-shrink: 0;
	width: 50px;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #0095ec;
	color: #ffffff;
	font-family: 'Poppins', Helvetica;
	font-size: 24px;
	font-weight: 600;
	border-radius: 10px;
}

.ccp-module-item__content {
	flex: 1;
	min-width: 0;
}

.ccp-module-item__title {
	color: #000000;
	font-family: 'Poppins', Helvetica;
	font-size: 20px;
	font-weight: 600;
	margin: 0 0 10px 0;
}

.ccp-module-item__description {
	color: rgba(0, 0, 0, 0.6);
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	font-weight: 400;
	line-height: 1.5;
	margin: 0;
}

.ccp-module-item__actions {
	display: flex;
	gap: 10px;
	flex-shrink: 0;
}

.ccp-module-item__btn {
	border: none;
	border-radius: 8px;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	font-weight: 500;
	padding: 10px 20px;
	cursor: pointer;
	transition: all 0.2s ease;
}

.ccp-module-item__btn--edit {
	background-color: rgba(0, 149, 236, 0.1);
	color: #0095ec;
}

.ccp-module-item__btn--edit:hover {
	background-color: rgba(0, 149, 236, 0.2);
	transform: translateY(-1px);
}

.ccp-module-item__btn--delete {
	background-color: rgba(255, 59, 48, 0.1);
	color: #ff3b30;
}

.ccp-module-item__btn--delete:hover {
	background-color: rgba(255, 59, 48, 0.2);
	transform: translateY(-1px);
}

/* MODULE CREATION SECTION */
.ccp-module-creation {
	display: flex;
	flex-direction: column;
	gap: 40px;
	width: 100%;
	padding: 20px 0;
}

/* CONFERENCES SECTION */
.ccp-conferences {
	width: 100%;
	padding: 20px 0;
}

/* Секция сертификатов */
.ccp-certificates {
	margin-top: 24px;
}

/* Модальное окно */
.ccp-modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	overflow: hidden;
	padding: 20px;
}

@media (min-width: 769px) and (max-width: 1366px) {
	.ccp-modal-overlay {
		padding: 28px;
	}
}

@media (min-width: 1367px) and (max-width: 1600px) {
	.ccp-modal-overlay {
		padding: 32px;
	}
}

@media (min-width: 1601px) and (max-width: 1800px) {
	.ccp-modal-overlay {
		padding: 36px;
	}
}

/*faq*/
.ccp-faq {
	width: 100%;
	margin-top: 20px;
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 1200px) {
	.ccp-container {
		padding: 20px 30px 80px;
	}

	.ccp-cover {
		height: 400px;
	}

	.ccp-cover__title {
		font-size: 36px;
	}

	.ccp-cover__subtitle {
		font-size: 28px;
	}
	
	.ccp-form__grid {
		gap: 18px 20px;
	}
}

@media (max-width: 768px) {
	.ccp-container {
		padding: 15px 20px 60px;
	}

	.ccp-breadcrumb {
		font-size: 14px;
		gap: 4px;
		margin-bottom: 15px;
	}

	.ccp-cover {
		height: 300px;
		margin-bottom: 20px;
	}

	.ccp-cover__title-group {
		left: 20px;
		top: 80px;
		right: 20px;
	}

	.ccp-cover__subtitle-group {
		left: 20px;
		top: 160px;
		right: 20px;
	}

	.ccp-cover__title {
		font-size: 28px;
		left: 36px;
		width: calc(100% - 60px);
	}

	.ccp-cover__subtitle {
		font-size: 22px;
		left: 36px;
		width: calc(100% - 60px);
	}

	.ccp-cover__upload-btn {
		left: 15px;
		top: 15px;
		width: 200px;
	}

	.ccp-cover__upload-bg {
		width: 200px;
	}

	.ccp-cover__upload-text {
		font-size: 16px;
	}

	.ccp-tabs {
		gap: 10px;
		height: auto;
		margin-bottom: 30px;
	}

	.ccp-tabs__item {
		font-size: 15px;
		height: 50px;
		padding: 0 20px;
		min-width: 120px;
	}

	.ccp-form__title {
		font-size: 26px;
	}

	.ccp-form__subtitle {
		font-size: 15px;
	}
	
	.ccp-form__grid {
		grid-template-columns: 1fr;
		gap: 16px;
	}

	.ccp-field__label,
	.ccp-field__textarea,
	.ccp-field__select,
	.ccp-field__input,
	.ccp-tags__input,
	.ccp-tags__add-btn {
		font-size: 14px;
	}

	.ccp-actions--sticky {
		padding: 12px 16px;
	}
	
	.ccp-actions__btn {
		font-size: 14px;
		height: 40px;
		padding: 0 20px;
		min-width: 120px;
	}
}

@media (max-width: 480px) {
	.ccp-container {
		padding: 10px 15px 40px;
	}

	.ccp-cover {
		height: 250px;
	}

	.ccp-cover__title {
		font-size: 24px;
	}

	.ccp-cover__subtitle {
		font-size: 18px;
	}

	.ccp-tabs__item {
		font-size: 13px;
		padding: 0 12px;
		min-width: 100px;
	}
	
	.ccp-actions {
		flex-direction: column;
		gap: 10px;
	}
	
	.ccp-actions__btn {
		width: 100%;
	}
}
</style>
